import {
  Box,
  Button,
  Divider,
  FormControlLabel,
  FormGroup,
  Grid,
  Checkbox,
  Typography,
  useTheme,
  TextField,
  Modal,
  FormControl,
  RadioGroup,
  Radio,
  Snackbar,
  Alert,
  AlertTitle,
  FormLabel,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import queryString from "query-string";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  checkPCC,
  emailItinerary,
  getManageBookingData,
  printItinerary,
} from "../redux/actions/AdminAction";
import CircularProgress from "@mui/material/CircularProgress";
import { styled } from "@mui/system";
import FlightLandIcon from "@mui/icons-material/FlightLand";
import FlightTakeoffIcon from "@mui/icons-material/FlightTakeoff";
import HorizontalRuleIcon from "@mui/icons-material/HorizontalRule";
import LoadingButton from "@mui/lab/LoadingButton";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  EMAIL_ITINERARY_DATA_RESET,
  PRINT_ITINERARY_DATA_RESET,
} from "../Constants/Constants";
import useMediaQuery from "@mui/material/useMediaQuery";

const StyledTextField = styled(TextField)({
  backgroundColor: "#EEEEEE",
  width: "80%",
  // display: "inline-block",
  padding: "4px 8px",
  borderRadius: "4px",
  fontSize: "inherit",
  fontFamily: "inherit",
  lineHeight: "inherit",
  "& .MuiInputBase-root": {
    backgroundColor: "transparent",
  },
  "& .MuiInputBase-input": {
    padding: 0,
    textAlign: "left",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "none",
  },
});

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  // border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const getEndorsementText = (pricing) => {
  let endorsements = [];

  if (Array.isArray(pricing?.endorsements) && pricing.endorsements.length > 0) {
    endorsements = pricing.endorsements.filter(Boolean);
  } else {
    endorsements = String(pricing?.endorsement || "")
      .split(/\r?\n/)
      .map((line) => line.trim())
      .filter(Boolean);
  }

  return endorsements.join(" / ");
};

export default function DisplayItinerary(props) {
  const { checkUserPermission, decodedToken } = props;
  const token = JSON.parse(localStorage.getItem("userInfo"));
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const theme = useTheme();
  const isLargeScreen = useMediaQuery("(max-width:1869px)");
  const isMediumScreen = useMediaQuery("(max-width:1740px)"); // For tablet responsiveness
  const isSmallScreen = useMediaQuery("(max-width:1300px)"); // For smaller screen responsiveness
  let lastDisplayedGroup = null;

  const [visibleCount, setVisibleCount] = useState(5);
  const [openModal, setOpenModal] = useState(false);
  const [openPDFModal, setOpenPDFModal] = useState(false);
  const [customerEmail, setCustomerEmail] = useState("");
  const [customerCC, setCustomerCC] = useState("");
  const [updatedHotel, setUpdatedHotel] = useState([]);
  const [updatedVehicle, setUpdatedVehicle] = useState([]);
  const [filteredFields, setFilteredFields] = useState([
    "PD",
    "TicketNumber",
    "AgencyName",
    "PNR", // Agency reference
    "check-in",
    "BC", // Booking class
    "activeSeg", // Active Segmemts
    // "Co2",
    // "Fare",
    // "OptionalService",
    "Baggage",
    // "FareCal",
    // "Hotel",
    // "Vehicle",
    "UR", // Unassociated Remarks
    // "npft", // Notepad Remarks
    // "di", // Accounting Remarks
    "Header",
    "Footer",
    // "TaxBreakdown",
  ]);
  const [hideFilters, setHideFilters] = useState(false);
  const [airPricing, setAirPricing] = useState([]);
  const [bookingTraveler, setBookingTraveler] = useState([]);
  const [bookingTravelerOtherInfo, setBookingTravelerOtherInfo] = useState([]);
  const [extraCharges, setExtraCharges] = useState([]);
  const [extraChargesTotalPrice, setExtraChargesTotalPrice] = useState(null);
  const [passengerData, setPassengerData] = useState({});
  const [agencyName, setAgencyName] = useState([]);
  const [agencyNumber, setAgencyNumber] = useState([]);
  const [pnr, setPnr] = useState("");
  const [passengerSelection, setPassengerSelection] = useState([]);
  const [segmentSelection, setSegmentSelection] = useState([]);
  const [selectAllPassenger, setSelectAllPassenger] = useState(true);
  const [selectAllSegment, setSelectAllSegment] = useState(true);
  const [hotelTotal, setHotelTotal] = useState(null);
  const [vehicleTotal, setVehicleTotal] = useState(null);
  const [totalPriceOfAllTickets, setTotalPriceOfAllTickets] = useState(null);
  const [remarkInfo, setRemarkInfo] = useState([]);
  const [npftRemark, setNpftRemark] = useState([]);
  const [diRemark, setDiRemark] = useState([]);
  const [passiveRemark, setPassiveRemark] = useState([]);
  const [flightTimesByGroup, setFlightTimesByGroup] = useState({});
  const [pdfChoice, setpdfChoice] = useState("");
  const [snackOpen, setSnackOpen] = useState(false);
  const [errorAlert, setErrorAlert] = useState(false);
  const [errorAlertMessage, setErrorAlertMessage] = useState("");
  const [language, setLanguage] = useState("en");
  const [services, setServices] = useState([{ type: "", fee: "" }]);
  const [totalServiceFees, setTotalServiceFees] = useState(null);
  const [itinerary_data, setItinerary_data] = useState(null);
  const [air_segments, setAir_segments] = useState(null);
  const [checkIn_hours, setCheckIn_hours] = useState(3);

  const { locator: statePNR, pcc: statePCC } = location.state || {};

  const { locator: UrlPnr, pcc: urlPcc } = queryString.parse(location.search);

  const locator = sessionStorage.getItem("pnr");
  const pcc = sessionStorage.getItem("pcc");

  const GetManageBookingData = useSelector(
    (state) => state.GetManageBookingData
  );

  const { loading, itineraryInfo, error } = GetManageBookingData;

  const EmailItineraryData = useSelector((state) => state.EmailItineraryData);

  const { emailItineraryLoading, emailItineraryInfo, emailItineraryError } =
    EmailItineraryData;

  const PrintItineraryData = useSelector((state) => state.PrintItineraryData);

  const { printItineraryLoading, printItineraryInfo, printItineraryError } =
    PrintItineraryData;

  const CheckPCC = useSelector((state) => state.CheckPCC);
  const { pcc_check, error: check_pcc_error } = CheckPCC;

  const currency =
    bookingTraveler &&
    (bookingTraveler
      ?.find((item) => item?.BasePrice)
      ?.BasePrice?.substring(0, 3) ||
      null);

  const passengerCounts = {};
  itinerary_data?.booking_traveler?.forEach((item) => {
    const type = item?.PassengerType;
    if (type) {
      passengerCounts[type] = (passengerCounts[type] || 0) + 1;
    }
  });
  let displayedPassengerTypes = new Set();
  let displayedPassengerTypesFareCalc = new Set();

  // Baggage and carray on allowance
  const travelerTypeOrder = ["ADT", "CNN", "INF"];
  const displayBaggage = {};

  const getDistinctBaggageInfo = (type) => {
    const seenRoutes = new Set();
    return (
      itinerary_data?.baggage_allowance?.filter((item) => {
        const route = `${item.From}-${item.To}`;
        if (item.TravelerType === type && !seenRoutes.has(route)) {
          seenRoutes.add(route);
          return true;
        }
        return false;
      }) || []
    );
  };

  const getDistinctBaggageInfoFromSegments = (type) => {
    const seenRoutes = new Set();
    return (
      itinerary_data?.air_segments_info?.filter((item) => {
        const route = `${item.From}-${item.To}`;
        if (item.PassengerTypeCode === type && !seenRoutes.has(route)) {
          seenRoutes.add(route);
          return true;
        }
        return false;
      }) || []
    );
  };

  travelerTypeOrder.forEach((type) => {
    displayBaggage[type] = getDistinctBaggageInfo(type);
  });

  const calculateFlightTimes = () => {
    const result = {};
    let groupCounter = {};
    let maxGroup = 0;

    itinerary_data?.air_segments_info?.forEach((segment) => {
      const group = Number(parseInt(segment.Group, 10));
      if (group > maxGroup) {
        maxGroup = group;
      }
    });

    itinerary_data?.air_segments_info?.forEach((segment) => {
      const group = Number(segment.Group);
      let totalFlightTime = 0;
      // let sum_totalFlightTime = 0;

      segment?.FlightDetails?.length > 0
        ? segment?.FlightDetails?.forEach((detail) => {
          if (detail.FlightTime) {
            totalFlightTime += parseInt(detail.FlightTime, 10) || 0;
          } else if (detail.TravelTime) {
            totalFlightTime += parseInt(detail.TravelTime, 10) || 0;
          }
        })
        : (totalFlightTime = 0);

      if (totalFlightTime > 0) {
        totalFlightTime += parseInt(segment.DurationInMinute, 10) || 0;
      }

      if (!groupCounter[group]) {
        groupCounter[group] = 0;
      }

      let groupLabel;
      if (maxGroup <= 1) {
        groupLabel = group === 0 ? "Outbound" : "Inbound";
      } else {
        groupLabel = `Outbound ${group + 1}`;
      }

      if (!result[groupLabel]) {
        result[groupLabel] = {
          group: group,
          totalFlightTime: 0,
          formattedFlightTime: "",
        };
      }

      // sum_totalFlightTime += totalFlightTime;
      result[groupLabel].totalFlightTime += totalFlightTime;
      result[groupLabel].formattedFlightTime = formatTime(
        result[groupLabel].totalFlightTime
      );
    });

    setFlightTimesByGroup(result);
  };

  // useEffect(() => {
  //   if (!checkUserPermission(102, "can_view")) {
  //     navigate("/home");
  //   }
  // }, [navigate, checkUserPermission]);

  useEffect(() => {
    if (!itineraryInfo) {
      if (statePNR && statePCC) {
        dispatch(getManageBookingData(statePNR, statePCC, decodedToken?.role));
      } else if (UrlPnr && urlPcc) {
        sessionStorage.setItem("pnr", UrlPnr);
        sessionStorage.setItem("pcc", urlPcc);
        dispatch(getManageBookingData(UrlPnr, urlPcc, decodedToken?.role));
      } else {
        dispatch(getManageBookingData(locator, pcc, decodedToken?.role));
      }
    }
    if (itineraryInfo) {
      setItinerary_data(itineraryInfo);
    }
  }, [itineraryInfo]);

  // useEffect(() => {
  //   if (filteredFields?.includes("activeSeg")) {
  //     const air_seg = itinerary_data?.air_segments_info?.filter(
  //       (item) => !item?.is_departed
  //     );
  //     setAir_segments(air_seg);
  //   } else {
  //     setAir_segments(itinerary_data?.air_segments_info);
  //   }
  // }, [filteredFields]);
  useEffect(() => {
    setAir_segments(itinerary_data?.air_segments_info);
  }, [filteredFields, itinerary_data]);

  useEffect(() => {
    if (pdfChoice != "") {
      setErrorAlert(false);
    }
  }, [pdfChoice]);

  useEffect(() => {
    if (emailItineraryInfo) {
      setTimeout(() => {
        setOpenModal(false);
        dispatch({ type: EMAIL_ITINERARY_DATA_RESET });
      }, 3000);
    }
  }, [emailItineraryInfo]);

  useEffect(() => {
    if (printItineraryInfo) {
      setOpenPDFModal(false);
      dispatch({ type: PRINT_ITINERARY_DATA_RESET });
    }
  }, [printItineraryInfo]);

  useEffect(() => {
    const totalFees = services.reduce((total, service) => {
      return total + (Number(service.fee) || 0);
    }, 0);

    setTotalServiceFees(totalFees.toFixed(2));
  }, [services]);

  useEffect(() => {
    if (!itinerary_data) {
      console.error("itineraryInfo is undefined. Cannot proceed.");
      return;
    }
    const clonedItineraryInfo = JSON.parse(JSON.stringify(itinerary_data));

    const totalPriceAllTickets = clonedItineraryInfo?.booking_traveler?.reduce(
      (accumulator, item) => {
        const passengerKey = item?.Key;
        const fare = passengerData[passengerKey]?.fare || null;
        const taxes = passengerData[passengerKey]?.taxes || null;
        const totalPrice = (Number(fare) + Number(taxes))?.toFixed(2);
        return accumulator + parseFloat(totalPrice);
      },
      0
    );
    setTotalPriceOfAllTickets(totalPriceAllTickets?.toFixed(2));

    const updatedHotelInfo = clonedItineraryInfo?.hotel_info?.map((item) => {
      const updatedItem = { ...item };
      if (updatedItem?.Rate) {
        updatedItem.Rate =
          String(updatedItem?.Rate?.substring(0, 3)) + hotelTotal;
      }
      return updatedItem;
    });

    setUpdatedHotel(updatedHotelInfo);

    const updatedVehicleInfo = clonedItineraryInfo?.vehicle_info?.map(
      (item) => {
        const updatedItem = { ...item };
        if (updatedItem?.estimatedTotalAmount) {
          updatedItem.estimatedTotalAmount =
            String(updatedItem?.estimatedTotalAmount?.substring(0, 3)) +
            vehicleTotal;
        }
        return updatedItem;
      }
    );

    setUpdatedVehicle(updatedVehicleInfo);

    setPnr(pnr);
  }, [passengerData, hotelTotal, vehicleTotal, pnr]);

  useEffect(() => {
    const extraChargesTotal = extraCharges?.reduce((accumulator, item) => {
      const total_cost = item?.TotalCost;
      const add_charges = item?.ExchangeTotalPrice;
      const totalPrice = (Number(total_cost) + Number(add_charges))?.toFixed(2);
      return accumulator + parseFloat(totalPrice);
    }, 0);
    setExtraChargesTotalPrice(extraChargesTotal?.toFixed(2));
  }, [extraCharges]);

  useEffect(() => {
    if (statePCC) dispatch(checkPCC(statePCC));
    if (urlPcc) dispatch(checkPCC(urlPcc));
    if (pcc) dispatch(checkPCC(pcc));
  }, [statePCC, urlPcc, pcc]);

  useEffect(() => {
    if (check_pcc_error) setSnackOpen(true);
  }, [check_pcc_error]);

  useEffect(() => {
    if (itinerary_data) {
      setCustomerEmail(itinerary_data?.customer?.email?.trim());
      setCustomerCC(itinerary_data?.customer?.cc?.trim());

      // if (filteredFields?.includes("activeSeg")) {
      //   const air_seg = itinerary_data?.air_segments_info?.filter(
      //     (item) => !item?.is_departed
      //   );
      //   setAir_segments(air_seg);
      // } else {
      //   setAir_segments(itinerary_data?.air_segments_info);
      // }
      setAir_segments(itinerary_data?.air_segments_info);
      if (itinerary_data?.booking_traveler) {
        const updatedPassengerData = itinerary_data.booking_traveler.reduce(
          (acc, item) => {
            acc[item?.Key] = {
              fare: item?.BasePrice?.substring(3) || 0,
              taxes: item?.Taxes?.substring(3) || 0,
            };
            return acc;
          },
          {}
        );
        setPassengerData(updatedPassengerData);
      }
      if (Array.isArray(itinerary_data?.air_pricing)) {
        setAirPricing(itinerary_data.air_pricing);
      } else {
        setAirPricing([]);
      }

      if (Array.isArray(itinerary_data?.booking_traveler)) {
        setBookingTraveler(itinerary_data.booking_traveler);
        setBookingTravelerOtherInfo(itinerary_data.booking_traveler);
      } else {
        setBookingTraveler([]);
        setBookingTravelerOtherInfo([]);
      }

      if (Array.isArray(itinerary_data?.extra_charges)) {
        setExtraCharges(itinerary_data.extra_charges);
      } else {
        setExtraCharges([]);
      }

      if (Array.isArray(itinerary_data?.agency_name)) {
        setAgencyName(itinerary_data.agency_name);
      } else {
        setAgencyName([]);
      }

      if (Array.isArray(itinerary_data?.agency_number)) {
        setAgencyNumber(itinerary_data.agency_number);
      } else {
        setAgencyNumber([]);
      }

      setPnr(itinerary_data?.locator);
      setRemarkInfo(itinerary_data?.remarks);
      // setNpftRemark(itinerary_data?.npft_remarks);
      setDiRemark(itinerary_data?.di_remarks);
      setPassiveRemark(itinerary_data?.passive_remarks);

      const clonedItineraryInfo = JSON.parse(JSON.stringify(itinerary_data));

      const totalPriceAllTickets =
        clonedItineraryInfo?.booking_traveler?.reduce((accumulator, item) => {
          const passengerKey = item?.Key;
          const fare = passengerData[passengerKey]?.fare || null;
          const taxes = passengerData[passengerKey]?.taxes || null;
          const totalPrice = (Number(fare) + Number(taxes))?.toFixed(2);
          return accumulator + parseFloat(totalPrice);
        }, 0);
      setTotalPriceOfAllTickets(totalPriceAllTickets?.toFixed(2));

      const extraChargesTotal = clonedItineraryInfo?.extra_charges?.reduce(
        (accumulator, item) => {
          const total_cost = item?.TotalCost;
          const add_charges = item?.ExchangeTotalPrice;
          const totalPrice = (
            Number(total_cost) + Number(add_charges)
          )?.toFixed(2);
          return accumulator + parseFloat(totalPrice);
        },
        0
      );
      setExtraChargesTotalPrice(extraChargesTotal?.toFixed(2));

      itinerary_data?.hotel_info?.map((item) => {
        setHotelTotal(item?.Rate?.substring(3) || 0);
      });

      itinerary_data?.vehicle_info?.map((item) => {
        setVehicleTotal(item?.estimatedTotalAmount?.substring(3) || 0);
      });

      if (itinerary_data?.booking_traveler) {
        const keys = itinerary_data.booking_traveler.map((item) => item?.Key);
        setPassengerSelection(keys);
      }

      if (itinerary_data?.air_segments_info) {
        const keys = itinerary_data.air_segments_info.map((item) => item?.Key);
        setSegmentSelection(keys);
      }

      calculateFlightTimes();
    }
  }, [itinerary_data]);

  useEffect(() => {
    const new_booking_traveler = bookingTraveler?.filter((item) =>
      passengerSelection?.includes(item?.Key)
    );
    setBookingTravelerOtherInfo(new_booking_traveler);

    const new_extra_charges = itinerary_data?.extra_charges?.filter((charge) =>
      new_booking_traveler?.some((traveler) =>
        traveler.Number?.includes(charge.AssociatedTicketNumber)
      )
    );

    setExtraCharges(new_extra_charges);
  }, [passengerSelection, bookingTraveler]);

  useEffect(() => {
    if (!bookingTraveler || !extraCharges) return;

    const updatedExtraCharges = extraCharges.map((item) => {
      const matchedTraveler = bookingTraveler.find((traveler) =>
        traveler.Number?.includes(item.AssociatedTicketNumber)
      );

      if (matchedTraveler) {
        return {
          ...item,
          PassengerName: matchedTraveler.Name,
        };
      }
      return item;
    });

    const isChanged = updatedExtraCharges.some(
      (updatedItem, index) =>
        updatedItem.PassengerName !== extraCharges[index]?.PassengerName
    );

    if (isChanged) {
      setExtraCharges(updatedExtraCharges);
    }
  }, [bookingTraveler, extraCharges]);

  const formatTime = (totalMinutes) => {
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return `${hours}h ${minutes}m`;
  };

  const handleFilteredFields = (event) => {
    const value = event.target.value;
    setFilteredFields((prevState) =>
      Array.isArray(prevState)
        ? event.target.checked
          ? [...prevState, value]
          : prevState.filter((v) => v !== value)
        : [value]
    );
  };

  const handleSelectAllPassenger = (event) => {
    const value = event.target.checked;
    if (value) {
      if (bookingTraveler) {
        const keys = bookingTraveler.map((item) => item?.Key);
        setPassengerSelection(keys);
      }
    } else {
      setPassengerSelection([]);
    }
    setSelectAllPassenger(value);
  };

  const handleSelectAllSegment = (event) => {
    const value = event.target.checked;
    if (value) {
      if (itinerary_data?.air_segments_info) {
        const keys = itinerary_data?.air_segments_info.map((item) => item?.Key);
        setSegmentSelection(keys);
      }
    } else {
      setSegmentSelection([]);
    }
    setSelectAllSegment(value);
  };

  const handlePassengerSelection = (event) => {
    const value = event.target.value;
    const isChecked = event.target.checked;
    setPassengerSelection((prevState) => {
      const newSelection = isChecked
        ? [...prevState, value]
        : prevState.filter((v) => v !== value);

      const allSelected = bookingTraveler?.every((item) =>
        newSelection.includes(item.Key)
      );

      setSelectAllPassenger(allSelected);

      return newSelection;
    });
  };

  // Function to update fare for a specific passenger
  const handleFareChange = (key, fare) => {
    setPassengerData((prevData) => ({
      ...prevData,
      [key]: {
        ...prevData[key],
        fare: fare,
      },
    }));
  };
  const handleFareChangeNew = (key, fare) => {
    setPassengerData((prevData) => ({
      ...prevData,
      [key]: {
        ...prevData[key],
        fare: fare,
      },
    }));
  };

  // Function to update taxes for a specific passenger
  const handleTaxesChange = (key, taxes) => {
    setPassengerData((prevData) => ({
      ...prevData,
      [key]: {
        ...prevData[key],
        taxes: taxes,
      },
    }));
  };

  const handleSegmentSelection = (event) => {
    const value = event.target.value;
    const isChecked = event.target.checked;
    setSegmentSelection((prevState) => {
      const newSelection = isChecked
        ? [...prevState, value]
        : prevState.filter((v) => v !== value);

      const allSelected = itinerary_data?.air_segments_info?.every((item) =>
        newSelection.includes(item.Key)
      );

      setSelectAllSegment(allSelected);

      return newSelection;
    });
  };

  const handleRemarkSelection = (item) => {
    setRemarkInfo((prevSelected) => {
      if (prevSelected.includes(item)) {
        return prevSelected.filter((remark) => remark !== item);
      } else {
        return [...prevSelected, item];
      }
    });
  };

  const handleNPFTRemarkSelection = (item) => {
    setNpftRemark((prevSelected) => {
      if (prevSelected.includes(item)) {
        return prevSelected.filter((remark) => remark !== item);
      } else {
        return [...prevSelected, item];
      }
    });
  };

  const handleDIRemarkSelection = (item) => {
    setDiRemark((prevSelected) => {
      if (prevSelected.includes(item)) {
        return prevSelected.filter((remark) => remark !== item);
      } else {
        return [...prevSelected, item];
      }
    });
  };

  const handlePassiveRemarksSelection = (item) => {
    setPassiveRemark((prevSelected) => {
      if (prevSelected.includes(item)) {
        return prevSelected.filter((remark) => remark !== item);
      } else {
        return [...prevSelected, item];
      }
    });
  };

  const handlePassengerDataChange = (index, field, value) => {
    const updatedTravelers = [...bookingTraveler];

    if (field.startsWith("Number.")) {
      const numberIndex = parseInt(field.split(".")[1], 10);
      const updatedNumbers = [...updatedTravelers[index].Number];
      updatedNumbers[numberIndex] = value;
      updatedTravelers[index] = {
        ...updatedTravelers[index],
        Number: updatedNumbers,
      };
    } else if (field.startsWith("LoyaltyCard.")) {
      const loyaltyIndex = parseInt(field.split(".")[1], 10);
      const updatedLoyaltyCards = [
        ...(updatedTravelers[index].LoyaltyCard || []),
      ];
      updatedLoyaltyCards[loyaltyIndex] = value;
      updatedTravelers[index] = {
        ...updatedTravelers[index],
        LoyaltyCard: updatedLoyaltyCards,
      };
    } else {
      updatedTravelers[index] = { ...updatedTravelers[index], [field]: value };
    }

    setBookingTraveler(updatedTravelers);
  };

  const handleExtraChargesDataChange = (index, field, value) => {
    const updatedCharges = [...extraCharges];
    updatedCharges[index] = { ...updatedCharges[index], [field]: value };
    setExtraCharges(updatedCharges);
  };

const createPDFData = (choice) => {
  const itinerary_info = JSON.parse(JSON.stringify(itinerary_data));
  let new_booking_traveler = [];

  if (choice == "PDFS" || pdfChoice == "PDFS") {
    new_booking_traveler = bookingTraveler?.filter((item) =>
      passengerSelection?.includes(item?.Key)
    );
  } else {
    // new_booking_traveler = itinerary_info?.booking_traveler;
    new_booking_traveler = bookingTraveler?.filter((item) =>
      passengerSelection?.includes(item?.Key)
    );
  }

  const new_air_segments_info = air_segments?.filter((item) =>
    segmentSelection?.includes(item?.Key)
  );

  const checkIn_reference = itinerary_info?.supplier_ref?.map((item) => item);

  const passenger_fare_details = airPricing?.map((item) => {
  const fareCurrency = item?.BasePrice?.substring(0, 3); // e.g., "USD"
  const fare = Number(item?.BasePrice?.replace(/[^\d.]/g, "")) || 0;
  const taxes = Number(item?.Taxes?.replace(/[^\d.]/g, "")) || 0;
  const passengerCount = passengerCounts[item?.PassengerTypeCode] || 1;

  return {
    passengerCount,
    PassengerType: item?.PassengerType,
    Fare: fare,
    Taxes: taxes,
    TotalAmount: ((fare + taxes) * passengerCount).toFixed(2),
    Currency: fareCurrency,   // ✅ correct key to use later
    tax_info: item?.tax_info,
    fare_calc: item?.fare_calc,
  };
});

// ✅ Calculate totals grouped by currency from passenger_fare_details
const totalsByCurrency = passenger_fare_details.reduce((acc, item) => {
  const curr = item?.Currency;  // ✅ FIXED: use Currency not fareCurrency
  if (curr) {
    const totalPerPassenger = (item?.Fare || 0) + (item?.Taxes || 0);
    const total = totalPerPassenger * (item?.passengerCount || 1);

    acc[curr] = (acc[curr] || 0) + total;
  }
  return acc;
}, {});


  // baggage info (unchanged)
  const baggage_info = travelerTypeOrder?.reduce((acc, travelerType) => {
    const baggageDetails = displayBaggage[travelerType]
      ?.map((item, index) => {
        const isFirstOfItsKind =
          index === 0 ||
          displayBaggage[travelerType][index - 1].From !== item.From ||
          displayBaggage[travelerType][index - 1].To !== item.To;

        if (
          isFirstOfItsKind &&
          item?.baggage?.length > 0 &&
          item?.baggage_info?.length > 0
        ) {
          return {
            origin_distination: `${item?.From} - ${item?.To}`,
            baggage_info: item?.baggage_info,
            baggage: item?.baggage,
            url: item?.URL,
          };
        }
        return null;
      })
      .filter((details) => details !== null);
    if (baggageDetails && baggageDetails.length > 0) {
      acc = { ...acc, [travelerType]: baggageDetails };
    }
    return acc;
  }, {});

  const service_data = services?.filter(
    (service) => service.type && service.fee
  );

  const data = {
    customer: itinerary_info?.customer,
    logo: itinerary_info?.customer?.logo,
    header_logo: itinerary_info?.customer?.header_logo,
    footer_logo: itinerary_info?.customer?.footer_logo,
    booking_traveler: filteredFields?.includes("PD")
      ? new_booking_traveler
      : [],
    booking_date: itinerary_info?.booking_date,
    show_ticket_number: filteredFields.includes("TicketNumber"),
    show_booking_class: filteredFields.includes("BC"),
    show_co2_emission: filteredFields.includes("Co2"),
    agency_name: filteredFields?.includes("AgencyName") && agencyName,
    agency_number: agencyNumber,
    agency_reference: filteredFields.includes("PNR") && pnr,
    checkIn_reference:
      filteredFields.includes("check-in") && checkIn_reference,
    flightTimesByGroup: flightTimesByGroup,
    air_segments_info: new_air_segments_info,
    bookingTravelerOtherInfo: bookingTravelerOtherInfo?.some(
      (item) => item?.OtherInfo?.length > 0
    )
      ? bookingTravelerOtherInfo
      : [],
    show_passenger_fare_details: filteredFields?.includes("Fare"),
    passenger_fare_details,
    totalsByCurrency,   // ✅ NEW field instead of totalPriceOfAllTickets
    show_optional_service: filteredFields?.includes("OptionalService"),
    extraCharges: filteredFields?.includes("OptionalService") && extraCharges,
    extraChargesTotalPrice:
      filteredFields?.includes("OptionalService") && extraChargesTotalPrice,
    fare_taxes_currency: currency,
    show_fare_calc: filteredFields?.includes("FareCal"),
    baggage_allowance: filteredFields?.includes("Baggage") && baggage_info,
    carry_on_allowance_info:
      filteredFields?.includes("Baggage") &&
      itinerary_info?.carry_on_allowance_info,
    hotel_info: filteredFields?.includes("Hotel") && updatedHotel,
    vehicle_info: filteredFields?.includes("Vehicle") && updatedVehicle,
    remarks: filteredFields?.includes("UR") && remarkInfo,
    diRemark: filteredFields?.includes("di") && diRemark,
    passiveRemark: filteredFields?.includes("pr") && passiveRemark,
    services:
      (filteredFields?.includes("Service") &&
        service_data.length > 0 &&
        service_data) ||
      {},
    totalServiceFees:
      filteredFields?.includes("Service") &&
      service_data.length > 0 &&
      totalServiceFees,
    show_header: filteredFields?.includes("Header"),
    show_footer: filteredFields?.includes("Footer"),
    show_taxbreakdown: filteredFields?.includes("TaxBreakdown"),
    show_endorsement: filteredFields?.includes("Endorsement"),
    show_technical_stops: filteredFields?.includes("stops"),
    checkIn_hours: checkIn_hours,
  };

  return data;
};


  const handlePrintToPDF = () => {
    const data = createPDFData("PDFS");
    dispatch(printItinerary(data,decodedToken?.role, language));
  };

  const handleOpenPDFModal = () => {
    setOpenPDFModal(true);
  };
  const handleClosePDFModal = () => {
    setOpenPDFModal(false);
    // setpdfChoice("PDFS");
  };

  const handleOpenModal = () => {
    setOpenModal(true);
    setpdfChoice("");
  };
  const handleCloseModal = () => {
    setOpenModal(false);
    // setpdfChoice("PDFS");
  };

  const handleSendEmail = () => {
    if (pdfChoice == "") {
      setErrorAlert(true);
      setErrorAlertMessage("Oops!! Kindly make your selections first");
    } else {
      setSnackOpen(true);
      const data = createPDFData();
      const email_data = {
        to: customerEmail,
        cc: customerCC,
        choice: pdfChoice,
      };

      dispatch(emailItinerary(data, email_data, decodedToken?.role, language));
    }
  };

  const handleSnackClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackOpen(false);
  };

  // Handler to add a new service
  const handleAddService = () => {
    setServices([...services, { type: "", fee: "" }]);
  };

  // Handler to remove a service by index
  const handleRemoveService = (index) => {
    if (services.length > 1) {
      const updatedServices = services.filter((_, i) => i !== index);
      setServices(updatedServices);
    }
  };

  // Handler to update service inputs
  const handleServiceChange = (index, field, value) => {
    const updatedServices = [...services];
    updatedServices[index][field] = value;
    setServices(updatedServices);
  };

  const handleSeeMore = () => {
    setVisibleCount((prevCount) =>
      Math.min(prevCount + 5, bookingTraveler.length)
    );
  };

  const handleSeeLess = () => {
    setVisibleCount(5);
  };

  return loading ? (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "70vh",
        marginBottom: "5%",
      }}
    >
      <CircularProgress sx={{ color: "black" }} />
    </Box>
  ) : check_pcc_error ? (
    <Snackbar
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      open={snackOpen}
      autoHideDuration={10000}
      onClose={handleSnackClose}
      sx={{ width: "20%" }}
    >
      <Alert onClose={handleSnackClose} severity="error" sx={{ width: "100%" }}>
        <AlertTitle>Error</AlertTitle>
        {check_pcc_error}
      </Alert>
    </Snackbar>
  ) : itinerary_data ? (
    <Grid
      container
      sx={{
        backgroundColor: "#f9f9f7",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginBottom: "5%",
      }}
    >
      <Grid
        // xs={12}
        sx={{ margin: 3, fontSize: 30, width: "80%", textAlign: "center" }}
      >
        E-Ticket & Itinerary Details
        <Divider sx={{ marginTop: 2 }}></Divider>
      </Grid>
      <Grid
        sx={{ width: isSmallScreen ? "98%" : isMediumScreen ? "90%" : "80%" }}
        container
        justifyContent="center"
      >
        <Grid container sx={{ marginTop: 1, marginBottom: "1.5%" }}>
          <Grid xs={9}>
            <FormGroup
              sx={{
                flexDirection: "row",
                // justifyContent: "space-between",
                marginRight: 4,
                // marginLeft: 1,
              }}
            >
              <FormControlLabel
                control={
                  <Checkbox
                    // style={{ color: "black" }}
                    value="PD"
                    checked={hideFilters}
                  />
                }
                label="Hide/Unhide Filters"
                onChange={(e) => setHideFilters(e.target.checked)}
              />
            </FormGroup>
            {hideFilters && (
              <FormGroup
                sx={{
                  flexDirection: "row",
                  // justifyContent: "space-between",
                  marginRight: 4,
                  // marginLeft: 1,
                }}
                onChange={handleFilteredFields}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      // style={{ color: "black" }}
                      value="PD"
                      checked={filteredFields?.includes("PD")}
                    />
                  }
                  label="Pax Details"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      // style={{ color: "black" }}
                      value="TicketNumber"
                      checked={filteredFields?.includes("TicketNumber")}
                    />
                  }
                  label="Ticket Number"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      // style={{ color: "black" }}
                      value="AgencyName"
                      checked={filteredFields?.includes("AgencyName")}
                    />
                  }
                  label="Agency Name"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      // style={{ color: "black" }}
                      value="PNR"
                      checked={filteredFields?.includes("PNR")}
                    />
                  }
                  label="Agency Reference"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      value="check-in"
                      checked={filteredFields?.includes("check-in")}
                    />
                  }
                  label="Check-in Reference"
                />

                {!filteredFields?.includes("stops") && (
                  <FormControlLabel
                    control={
                      <Checkbox
                        value="BC"
                        checked={filteredFields?.includes("BC")}
                      />
                    }
                    label="Booking class"
                  />
                )}

                <FormControlLabel
                  control={
                    <Checkbox
                      value="Baggage"
                      checked={filteredFields?.includes("Baggage")}
                    />
                  }
                  label="Baggage & Carry On Allowance"
                />

                <FormControlLabel
                  control={
                    <Checkbox
                      value="UR"
                      checked={filteredFields?.includes("UR")}
                    />
                  }
                  label="Unassociated Remark"
                />

                {/*<FormControlLabel
                  control={
                    <Checkbox
                      value="npft"
                      checked={filteredFields?.includes("npft")}
                    />
                  }
                  label="Notepad Remarks (NP FT)"
                />*/}

                <FormControlLabel
                  control={
                    <Checkbox
                      value="di"
                      checked={filteredFields?.includes("di")}
                    />
                  }
                  label="Accounting Remarks (DI)"
                />

                {passiveRemark?.length > 0 && (
                  <FormControlLabel
                    control={
                      <Checkbox
                        value="pr"
                        checked={filteredFields?.includes("pr")}
                      />
                    }
                    label="Passive Remarks"
                  />
                )}

                <FormControlLabel
                  control={
                    <Checkbox
                      value="Header"
                      checked={filteredFields?.includes("Header")}
                    />
                  }
                  label="Agency Header"
                />

                <FormControlLabel
                  control={
                    <Checkbox
                      value="activeSeg"
                      checked={filteredFields?.includes("activeSeg")}
                    />
                  }
                  label="Active Segments"
                />

                <FormControlLabel
                  control={
                    <Checkbox
                      value="stops"
                      checked={filteredFields?.includes("stops")}
                    />
                  }
                  label="Technical Stops Details"
                />

                {!filteredFields?.includes("stops") && (
                  <FormControlLabel
                    control={
                      <Checkbox
                        value="Co2"
                        checked={filteredFields?.includes("Co2")}
                      />
                    }
                    label="Co2 information"
                  />
                )}

                <FormControlLabel
                  control={
                    <Checkbox
                      value="Fare"
                      checked={filteredFields?.includes("Fare")}
                    />
                  }
                  label="Fare and Taxes"
                />

                <FormControlLabel
                  control={
                    <Checkbox
                      value="TaxBreakdown"
                      checked={filteredFields?.includes("TaxBreakdown")}
                    />
                  }
                  label="Tax Breakdown"
                />

                <FormControlLabel
                  control={
                    <Checkbox
                      value="Endorsement"
                      checked={filteredFields?.includes("Endorsement")}
                    />
                  }
                  label="Endorsement"
                />

                <FormControlLabel
                  control={
                    <Checkbox
                      value="OptionalService"
                      checked={filteredFields?.includes("OptionalService")}
                    />
                  }
                  label="Optional Services"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      value="FareCal"
                      checked={filteredFields?.includes("FareCal")}
                    />
                  }
                  label="Fare Calculations"
                />

                <FormControlLabel
                  control={
                    <Checkbox
                      value="Service"
                      checked={filteredFields?.includes("Service")}
                    />
                  }
                  label="Service fees"
                />

                <FormControlLabel
                  control={
                    <Checkbox
                      value="Hotel"
                      checked={filteredFields?.includes("Hotel")}
                    />
                  }
                  label="Hotel Details"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      value="Vehicle"
                      checked={filteredFields?.includes("Vehicle")}
                    />
                  }
                  label="Vehicle Details"
                />

                <FormControlLabel
                  control={
                    <Checkbox
                      value="Footer"
                      checked={filteredFields?.includes("Footer")}
                    />
                  }
                  label="Agency Footer"
                />
              </FormGroup>
            )}
          </Grid>
          <Grid
            xs={3}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: 1,
            }}
          >
            <Button
              size="small"
              sx={{
                backgroundColor: "#282828",
                border: "1px solid #313639",
                color: "#ffffff",
                width: isSmallScreen
                  ? "40vh"
                  : isMediumScreen
                    ? "40vh"
                    : "20vh",
                height: "3vh",
                fontWeight: "bold",
                fontSize: isSmallScreen ? 10 : isMediumScreen ? 12 : 14,
                "&:hover": {
                  backgroundColor: "#282828",
                  color: "#ffffff",
                },
              }}
              onClick={handleOpenPDFModal}
            >
              Print to pdf
            </Button>
            <Button
              size="small"
              sx={{
                marginLeft: 1,
                backgroundColor: "#282828",
                border: "1px solid #313639",
                color: "#ffffff",
                width: isSmallScreen
                  ? "40vh"
                  : isMediumScreen
                    ? "40vh"
                    : "30vh",
                height: "3vh",
                fontWeight: "bold",
                fontSize: isSmallScreen ? 10 : isMediumScreen ? 12 : 14,
                "&:hover": {
                  backgroundColor: "#282828",
                  color: "#ffffff",
                },
              }}
              onClick={handleOpenModal}
            >
              Email this itinerary
            </Button>
          </Grid>
        </Grid>
        <Grid container sx={{ marginTop: 2, marginBottom: "1%" }}>
          <Grid
            xs={12}
            sx={{
              fontSize: 20,
              textTransform: "uppercase",
            }}
          >
            CHECK-IN COMMENCES
            <StyledTextField
              sx={{
                width: "1.5%",
                marginTop: -0.5,
                marginLeft: 1,
                marginRight: 1,
              }}
              value={checkIn_hours}
              onChange={(e) => {
                const value = e.target.value;
                // Allow only digits and limit to 2 characters
                if (/^\d{1,2}$/.test(value) || value === "") {
                  setCheckIn_hours(value);
                }
              }}
              variant="outlined"
              inputProps={{ style: { padding: 0 } }}
            />
            HOURS PRIOR TO THE SCHEDULED DEPARTURE
          </Grid>
        </Grid>
        {filteredFields?.includes("PD") && bookingTraveler?.length > 0 && (
          <Grid container sx={{ marginTop: 1, marginBottom: "1.5%" }}>
            <Grid
              xs={12}
              sx={{
                backgroundColor: "#3e3b39",
                color: "white",
                height: "4vh",
                padding: 1,
                fontSize: 18,
                textTransform: "uppercase",
              }}
            >
              Passenger Details
            </Grid>
            <Grid
              container
              sx={{
                marginTop: 1,
                backgroundColor: "#d8d9da",
                height: "4vh",
                padding: 1,
                fontSize: 18,
              }}
            >
              <Grid xs={1}>
                <Checkbox
                  sx={{ marginTop: -1, marginLeft: 0.4 }}
                  value={selectAllPassenger}
                  checked={selectAllPassenger}
                  onChange={handleSelectAllPassenger}
                />
              </Grid>
              <Grid xs={1.5}>Passenger Type</Grid>
              <Grid xs={3.5}>Last Name/First Name</Grid>
              <Grid xs={2}>Loyalty Program</Grid>
              <Grid xs={1.5}>Disabilities</Grid>
              <Grid xs={2.5}>Electronic Ticket nbr</Grid>
            </Grid>
            {bookingTraveler?.slice(0, visibleCount)?.map((item, index) => {
              return (
                <Grid
                  container
                  sx={{
                    margin: 0.8,
                    padding: theme.spacing(0.5),
                    // boxShadow: "inset 0 -1px 0 0 #F1EEE9",
                  }}
                >
                  <Grid container>
                    <Grid xs={1}>
                      <Checkbox
                        sx={{ marginTop: -1.5 }}
                        value={item.Key}
                        checked={passengerSelection?.includes(item?.Key)}
                        onChange={handlePassengerSelection}
                      />
                    </Grid>
                    <Grid xs={1.5}>{item?.PassengerType}</Grid>
                    <Grid xs={3.5}>
                      <StyledTextField
                        fullWidth
                        value={item?.Name}
                        onChange={(e) => {
                          const value = e.target.value;
                          handlePassengerDataChange(index, "Name", value || "");
                        }}
                        variant="outlined"
                        inputProps={{
                          style: {
                            padding: 0,
                          },
                        }}
                      />
                    </Grid>
                    <Grid xs={2}>
                      {item?.LoyaltyCard?.map((loyaltyCard, loyaltyIndex) => (
                        <StyledTextField
                          key={loyaltyIndex}
                          sx={{
                            marginBottom: 0.5,
                            width: "90%",
                            maxHeight: "2.5vh",
                          }}
                          value={loyaltyCard}
                          onChange={(e) => {
                            const value = e.target.value;
                            handlePassengerDataChange(
                              index,
                              `LoyaltyCard.${loyaltyIndex}`,
                              value || ""
                            );
                          }}
                          variant="outlined"
                          placeholder="Loyalty Card"
                          inputProps={{
                            style: {
                              padding: 0,
                            },
                          }}
                        />
                      ))}
                    </Grid>
                    <Grid xs={1.5}>
                      {item?.Disabilities.length > 0
                        ? item.Disabilities.map((disability, idx) => (
                          <Typography key={idx}>
                            {disability === "BLND"
                              ? "Traveler is blind"
                              : disability === "DEAF"
                                ? "Traveler is deaf"
                                : disability}
                          </Typography>
                        ))
                        : null}
                    </Grid>
                    <Grid
                      xs={2.5}
                      sx={{ display: "flex", justifyContent: "space-between" }}
                    >
                      {filteredFields?.includes("TicketNumber") &&
                              (item?.Number && item.Number.length > 0 ? item.Number : [""]).map(
                                (value, valueindex) => {
                                  return (
                                    <StyledTextField
                                      key={valueindex}
                                      sx={{
                                        width: "35%",
                                      }}
                                      value={value ?? ""} // fallback empty
                                      onChange={(e) => {
                                        const newValue = e.target.value;
                                        handlePassengerDataChange(
                                          index,
                                          `Number.${valueindex}`,
                                          newValue || ""
                                        );
                                      }}
                                      variant="outlined"
                                      inputProps={{
                                        style: {
                                          padding: 0,
                                        },
                                      }}
                                    />
                                  );
                                }
                              )}
                    </Grid>
                  </Grid>
                </Grid>
              );
            })}
            {bookingTraveler?.length > visibleCount && (
              <Grid container justifyContent="center" sx={{ marginTop: 1 }}>
                <Button onClick={handleSeeMore}>See More</Button>
              </Grid>
            )}
            {bookingTraveler?.length == visibleCount && (
              <Grid container justifyContent="center" sx={{ marginTop: 1 }}>
                <Button onClick={handleSeeLess}>See less</Button>
              </Grid>
            )}
          </Grid>
        )}

        <Grid container sx={{ marginTop: 1, marginBottom: "1.5%" }}>
          <Grid
            xs={12}
            sx={{
              backgroundColor: "#3e3b39",
              color: "white",
              height: "4vh",
              padding: 1,
              fontSize: 18,
              textTransform: "uppercase",
            }}
          >
            Booking Details
          </Grid>
          <Grid
            container
            sx={{
              marginTop: 2,
              backgroundColor: "#d8d9da",
              // height: "4vh",
              padding: 1,
              fontSize: 18,
            }}
          >
            <Grid xs={4}>Agency Name</Grid>
            <Grid xs={3}>Agency Number</Grid>
            <Grid xs={3}>Agency Reference</Grid>
            <Grid xs={2}>Check-in Reference</Grid>
          </Grid>
          <Grid
            container
            sx={{
              margin: 0.8,
              padding: theme.spacing(0.5),
            }}
          >
            <Grid xs={4} sx={{ margin: 0 }}>
              {filteredFields?.includes("AgencyName") ? (
                agencyName.length > 0 ? (
                  agencyName?.map((item, index) => {
                    return (
                      <StyledTextField
                        key={index}
                        sx={{ marginRight: 2, marginTop: index > 0 ? 0.5 : 0 }}
                        value={item}
                        onChange={(e) => {
                          const newAgencyName = [...agencyName];
                          newAgencyName[index] = e.target.value;
                          setAgencyName(newAgencyName);
                        }}
                        variant="outlined"
                        inputProps={{ style: { padding: 0 } }}
                      />
                    );
                  })
                ) : (
                  <StyledTextField
                    sx={{ margin: 0 }}
                    // value={agencyName}
                    onChange={(e) => {
                      const new_value = e.target.value;
                      setAgencyName([...new_value]);
                    }}
                    variant="outlined"
                    inputProps={{ style: { padding: 0 } }}
                  />
                )
              ) : null}
            </Grid>
            <Grid xs={3}>
              {itinerary_data?.agency_number?.length > 0 ? (
                itinerary_data?.agency_number?.map((item) => {
                  return <Typography>{item}</Typography>;
                })
              ) : (
                <StyledTextField
                  sx={{ marginRight: 2 }}
                  onChange={(e) => {
                    const new_value = e.target.value;
                    setAgencyNumber([new_value]);
                  }}
                  type="number"
                  variant="outlined"
                  inputProps={{ style: { padding: 0 } }}
                />
              )}
            </Grid>
            <Grid xs={3}>
              {filteredFields?.includes("PNR") && itinerary_data?.locator && (
                <StyledTextField
                  sx={{ marginRight: 2 }}
                  value={pnr}
                  onChange={(e) => setPnr(e.target.value)}
                  variant="outlined"
                  inputProps={{ style: { padding: 0 } }}
                />
              )}
            </Grid>
            <Grid xs={2}>
              {filteredFields?.includes("check-in") &&
                itinerary_data?.supplier_ref?.map((item) => {
                  return (
                    <Typography>
                      {item[0]}/<b>{item[1]}</b>
                    </Typography>
                  );
                })}
            </Grid>
          </Grid>
        </Grid>

        {air_segments?.length > 0 && (
          <>
            <Grid container>
              <Grid
                xs={12}
                sx={{
                  backgroundColor: "#3e3b39",
                  color: "white",
                  height: "4vh",
                  padding: 1,
                  fontSize: 18,
                  textTransform: "uppercase",
                }}
              >
                Flight Details
              </Grid>
              <Grid
                container
                sx={{
                  marginTop: 1,
                  backgroundColor: "#d8d9da",
                  height: "4vh",
                  padding: 1,
                  fontSize: 18,
                  fontWeight: "bold",
                  // textAlign: "center",
                }}
              >
                <Grid xs={0.5}>
                  <Checkbox
                    sx={{ marginTop: -1, marginLeft: 1 }}
                    value={selectAllSegment}
                    checked={selectAllSegment}
                    onChange={handleSelectAllSegment}
                  />
                </Grid>
                <Grid xs={2}>Airline</Grid>
                <Grid xs={2.5}>Departure</Grid>
                <Grid xs={2.5}>Arrival</Grid>
                <Grid xs={4.5}>Other Information</Grid>
              </Grid>

              {air_segments?.map((segment, segIndex) => {
                return (
                  <Grid xs={12}>
                    {Object.entries(flightTimesByGroup)?.map(([key, value]) => {
                      if (
                        value.group === Number(segment.Group) &&
                        value.group !== lastDisplayedGroup
                      ) {
                        lastDisplayedGroup = value.group;

                        return (
                          <Grid
                            key={key}
                            xs={12}
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              backgroundColor: "#EEEEEE",
                              padding: 1,
                              marginTop: 1,
                              fontSize: 18,
                              borderRadius: 2,
                              fontWeight: "bold",
                            }}
                          >
                            <span sx={{ textTransform: "uppercase" }}>
                              {key}
                            </span>
                            <span>
                              Total Duration: {value.formattedFlightTime}
                            </span>
                          </Grid>
                        );
                      }

                      // return null;
                    })}
                    <Grid
                      sx={{
                        boxShadow: "inset 0 -1px 0 0 #F1EEE9",
                      }}
                    >
                      <Grid
                        container
                        sx={{
                          margin: 1,
                          padding: theme.spacing(1),
                        }}
                      >
                        <Grid xs={0.4}>
                          <Checkbox
                            sx={{ marginLeft: 0 }}
                            value={segment.Key}
                            checked={segmentSelection?.includes(segment?.Key)}
                            onChange={handleSegmentSelection}
                          />
                        </Grid>
                        <Grid xs={2} sx={{ marginTop: 1 }}>
                          <img
                            src={`data:image/png;base64,${segment.AirlineLogo}`}
                            alt="Airline Logo"
                            width="auto"
                            height="auto"
                            style={{
                              verticalAlign: "bottom",
                              marginTop: 0,
                              maxWidth: "90%",
                              marginBottom: 5,
                            }}
                          />
                          <Typography>{segment?.AirlineName}</Typography>
                          <Typography>{segment?.Flight}</Typography>
                          <Typography>
                            <span style={{ fontWeight: "bold" }}>
                              Aircraft :
                            </span>{" "}
                            {segment?.AircraftName}
                          </Typography>
                          <Typography>
                            <span style={{ fontWeight: "bold" }}>
                              Stop(s) :
                            </span>{" "}
                            {segment.NumberOfStops
                              ? segment.NumberOfStops
                              : "Non-Stop"}
                            <br />
                            {segment.NumberOfStops
                              ? segment?.FlightDetails?.slice(
                                0,
                                segment.NumberOfStops
                              )
                                ?.map((item) => item.ToCity)
                                ?.join(" / ")
                              : null}
                          </Typography>

                          <Typography>
                            <span style={{ fontWeight: "bold" }}>
                              Duration :
                            </span>{" "}
                            {segment.FlightTime}
                          </Typography>
                        </Grid>
                        <Grid xs={2.5}>
                          {!filteredFields?.includes("stops") ? (
                            // segment?.FlightDetails?.length > 0 ? (
                            //   <Grid sx={{ height: "230px" }}>
                            //     <Typography sx={{ fontWeight: "bold" }}>
                            //       <FlightTakeoffIcon />{" "}
                            //       {segment?.FlightDetails[0]?.FromAirport} (
                            //       {segment?.FlightDetails[0]?.From})
                            //     </Typography>
                            //     <Typography>
                            //       {segment?.FlightDetails[0]?.FromCity}
                            //     </Typography>
                            //     <Typography>
                            //       {segment?.FlightDetails[0]?.FromCountry}
                            //     </Typography>
                            //     <Typography sx={{ fontWeight: "bold" }}>
                            //       Departing At
                            //     </Typography>
                            //     <Typography>
                            //       {segment?.FlightDetails[0]?.Departs},{" "}
                            //       <b>
                            //         {segment?.FlightDetails[0]?.DepartsTime}
                            //       </b>
                            //     </Typography>
                            //     <Typography>
                            //       Terminal:{" "}
                            //       {segment?.FlightDetails[0]?.FromTerminal}
                            //     </Typography>
                            //     <Typography
                            //       sx={{
                            //         wordBreak: "break-word",
                            //         whiteSpace: "normal",
                            //         width: "90%",
                            //       }}
                            //     >
                            //       {segment.OperatedBy
                            //         ? `Operated By: ${segment?.OperatedBy}`
                            //         : `Operated By: ${segment?.AirlineName}`}
                            //     </Typography>
                            //   </Grid>
                            // ) : (
                            <Grid sx={{ height: "230px" }}>
                              <Typography sx={{ fontWeight: "bold" }}>
                                <FlightTakeoffIcon /> {segment?.FromAirport} (
                                {segment?.From})
                              </Typography>
                              <Typography>{segment?.FromCity}</Typography>
                              <Typography>{segment?.FromCountry}</Typography>
                              <Typography sx={{ fontWeight: "bold" }}>
                                Departing At
                              </Typography>
                              <Typography>
                                {segment?.Departs},{" "}
                                <b>{segment?.DepartsTime}</b>
                              </Typography>
                              <Typography>
                                Terminal: {segment?.FromTerminal}
                              </Typography>
                              <Typography
                                sx={{
                                  wordBreak: "break-word",
                                  whiteSpace: "normal",
                                  width: "90%",
                                }}
                              >
                                {segment.OperatedBy
                                  ? `Operated By: ${segment?.OperatedBy}`
                                  : `Operated By: ${segment?.AirlineName}`}
                              </Typography>
                            </Grid>
                          ) : // )
                            segment?.FlightDetails?.length > 0 ? (
                              segment?.FlightDetails?.map((flight_details) => {
                                return (
                                  <Grid sx={{ height: "230px" }}>
                                    <Typography sx={{ fontWeight: "bold" }}>
                                      <FlightTakeoffIcon />{" "}
                                      {flight_details?.FromAirport} (
                                      {flight_details?.From})
                                    </Typography>
                                    <Typography>
                                      {flight_details?.FromCity}
                                    </Typography>
                                    <Typography>
                                      {flight_details?.FromCountry}
                                    </Typography>
                                    <Typography sx={{ fontWeight: "bold" }}>
                                      Departing At
                                    </Typography>
                                    <Typography>
                                      {flight_details?.Departs},{" "}
                                      <b>{flight_details?.DepartsTime}</b>
                                    </Typography>
                                    <Typography>
                                      Terminal: {flight_details?.FromTerminal}
                                    </Typography>
                                    <Typography
                                      sx={{
                                        wordBreak: "break-word",
                                        whiteSpace: "normal",
                                        width: "90%",
                                      }}
                                    >
                                      {segment.OperatedBy
                                        ? `Operated By: ${segment?.OperatedBy}`
                                        : `Operated By: ${segment?.AirlineName}`}
                                    </Typography>
                                  </Grid>
                                );
                              })
                            ) : (
                              <>
                                <Grid sx={{ height: "200px" }}>
                                  <Typography sx={{ fontWeight: "bold" }}>
                                    <FlightTakeoffIcon /> {segment?.FromAirport} (
                                    {segment?.From})
                                  </Typography>
                                  <Typography>{segment?.FromCity}</Typography>
                                  <Typography>{segment?.FromCountry}</Typography>
                                  <Typography sx={{ fontWeight: "bold" }}>
                                    Departing At
                                  </Typography>
                                  <Typography>
                                    {segment?.Departs},{" "}
                                    <b>{segment?.DepartsTime}</b>
                                  </Typography>
                                  <Typography>
                                    Terminal: {segment?.FromTerminal}
                                  </Typography>
                                  <Typography>
                                    {segment.OperatedBy
                                      ? `Operated By: ${segment?.OperatedBy}`
                                      : `Operated By: ${segment?.AirlineName}`}
                                  </Typography>
                                </Grid>
                              </>
                            )}
                        </Grid>
                        <Grid xs={2.5}>
                          {!filteredFields?.includes("stops") ? (
                            // segment?.FlightDetails?.length > 0 ? (
                            //   <Grid sx={{ height: "230px" }}>
                            //     <Typography sx={{ fontWeight: "bold" }}>
                            //       <FlightLandIcon />{" "}
                            //       {
                            //         segment?.FlightDetails[
                            //           segment?.FlightDetails.length - 1
                            //         ]?.ToAirport
                            //       }{" "}
                            //       (
                            //       {
                            //         segment?.FlightDetails[
                            //           segment?.FlightDetails.length - 1
                            //         ]?.To
                            //       }
                            //       )
                            //     </Typography>
                            //     <Typography>
                            //       {
                            //         segment?.FlightDetails[
                            //           segment?.FlightDetails.length - 1
                            //         ]?.ToCity
                            //       }
                            //     </Typography>
                            //     <Typography>
                            //       {
                            //         segment?.FlightDetails[
                            //           segment?.FlightDetails.length - 1
                            //         ]?.ToCountry
                            //       }
                            //     </Typography>
                            //     <Typography sx={{ fontWeight: "bold" }}>
                            //       Arriving At
                            //     </Typography>
                            //     <Typography>
                            //       {
                            //         segment?.FlightDetails[
                            //           segment?.FlightDetails.length - 1
                            //         ]?.Arrives
                            //       }
                            //       ,{" "}
                            //       <b>
                            //         {
                            //           segment?.FlightDetails[
                            //             segment?.FlightDetails.length - 1
                            //           ]?.ArrivesTime
                            //         }
                            //       </b>
                            //     </Typography>
                            //     <Typography>
                            //       Terminal:{" "}
                            //       {
                            //         segment?.FlightDetails[
                            //           segment?.FlightDetails.length - 1
                            //         ]?.ToTerminal
                            //       }
                            //     </Typography>
                            //   </Grid>
                            // ) : (
                            <Grid sx={{ height: "230px" }}>
                              <Typography sx={{ fontWeight: "bold" }}>
                                <FlightLandIcon /> {segment?.ToAirport} (
                                {segment?.To})
                              </Typography>
                              <Typography>{segment?.ToCity}</Typography>
                              <Typography>{segment?.ToCountry}</Typography>
                              <Typography sx={{ fontWeight: "bold" }}>
                                Arriving At
                              </Typography>
                              <Typography>
                                {segment?.Arrives},{" "}
                                <b>{segment?.ArrivesTime}</b>
                              </Typography>
                              <Typography>
                                Terminal: {segment?.ToTerminal}
                              </Typography>
                            </Grid>
                          ) : // )
                            segment?.FlightDetails?.length > 0 ? (
                              segment?.FlightDetails?.map((flight_details) => {
                                return (
                                  <Grid sx={{ height: "230px" }}>
                                    <Typography sx={{ fontWeight: "bold" }}>
                                      <FlightLandIcon />{" "}
                                      {flight_details?.ToAirport} (
                                      {flight_details?.To})
                                    </Typography>
                                    <Typography>
                                      {flight_details?.ToCity}
                                    </Typography>
                                    <Typography>
                                      {flight_details?.ToCountry}
                                    </Typography>
                                    <Typography sx={{ fontWeight: "bold" }}>
                                      Arriving At
                                    </Typography>
                                    <Typography>
                                      {flight_details?.Arrives},{" "}
                                      <b>{flight_details?.ArrivesTime}</b>
                                    </Typography>
                                    <Typography>
                                      Terminal: {flight_details?.ToTerminal}
                                    </Typography>
                                  </Grid>
                                );
                              })
                            ) : (
                              <>
                                <Grid sx={{ height: "200px" }}>
                                  <Typography sx={{ fontWeight: "bold" }}>
                                    <FlightLandIcon /> {segment?.ToAirport} (
                                    {segment?.To})
                                  </Typography>
                                  <Typography>{segment?.ToCity}</Typography>
                                  <Typography>{segment?.ToCountry}</Typography>
                                  <Typography sx={{ fontWeight: "bold" }}>
                                    Arriving At
                                  </Typography>
                                  <Typography>
                                    {segment?.Arrives},{" "}
                                    <b>{segment?.ArrivesTime}</b>
                                  </Typography>
                                  <Typography>
                                    Terminal: {segment?.ToTerminal}
                                  </Typography>
                                </Grid>
                              </>
                            )}
                        </Grid>
                        <Grid xs={4.5}>
                          {!filteredFields?.includes("stops") &&
                            segment.NumberOfStops > 0 ? (
                            <>
                              <Grid
                                sx={{
                                  height:
                                    segment?.FlightDetails?.length > 1
                                      ? "33%"
                                      : "60%",
                                }}
                              >
                                <Grid
                                  sx={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    marginTop: 0,
                                    alignItems: "flex-start",
                                    height: isSmallScreen
                                      ? "17vh"
                                      : isMediumScreen
                                        ? "17vh"
                                        : "15vh",
                                  }}
                                >
                                  <Grid
                                    // item
                                    xs={5.7}
                                    sx={{
                                      backgroundColor: "#EEEEEE",
                                      display: "flex",
                                      justifyContent: "space-between",
                                      // marginBottom: 0.5,
                                      padding: 0.5,
                                      flexGrow: 1,
                                      marginRight: 1,
                                    }}
                                  >
                                    <span style={{ fontWeight: "bold" }}>
                                      Status
                                    </span>
                                    <span>
                                      {segment.SegmentStatus ? (
                                        segment.SegmentStatus
                                      ) : (
                                        <HorizontalRuleIcon
                                          sx={{ fontSize: "small" }}
                                        />
                                      )}
                                    </span>
                                  </Grid>

                                  <Grid
                                    // item
                                    xs={5.7}
                                    sx={{
                                      backgroundColor: "#EEEEEE",
                                      display: "flex",
                                      justifyContent: "space-between",
                                      // marginBottom: 0.5,
                                      padding: 0.5,
                                      flexGrow: 1,
                                      marginRight: 1,
                                    }}
                                  >
                                    <span style={{ fontWeight: "bold" }}>
                                      Cabin
                                    </span>
                                    <span>
                                      {segment.Cabin ? (
                                        segment.Cabin
                                      ) : (
                                        <HorizontalRuleIcon
                                          sx={{ fontSize: "small" }}
                                        />
                                      )}
                                    </span>
                                  </Grid>

                                  <Grid
                                    // item
                                    xs={5.7}
                                    sx={{
                                      backgroundColor: "#EEEEEE",
                                      display: "flex",
                                      justifyContent: "space-between",
                                      // marginBottom: 0.5,
                                      padding: 0.5,
                                      flexGrow: 1,
                                      marginRight: 1,
                                    }}
                                  >
                                    <span style={{ fontWeight: "bold" }}>
                                      Booking Class
                                    </span>
                                    {filteredFields?.includes("BC") && (
                                      <span>
                                        {segment.BookingClass ? (
                                          segment.BookingClass
                                        ) : (
                                          <HorizontalRuleIcon
                                            sx={{ fontSize: "small" }}
                                          />
                                        )}
                                      </span>
                                    )}
                                  </Grid>

                                  <Grid
                                    // item
                                    xs={5.7}
                                    sx={{
                                      backgroundColor: "#EEEEEE",
                                      display: "flex",
                                      justifyContent: "space-between",
                                      // marginBottom: 0.5,
                                      padding: 0.5,
                                      flexGrow: 1,
                                      marginRight: 1,
                                    }}
                                  >
                                    <span style={{ fontWeight: "bold" }}>
                                      Co2 emission
                                    </span>

                                    <HorizontalRuleIcon
                                      sx={{ fontSize: "small" }}
                                    />
                                  </Grid>
                                  <Grid
                                    // item
                                    xs={5.7}
                                    sx={{
                                      backgroundColor: "#EEEEEE",
                                      display: "flex",
                                      justifyContent: "space-between",
                                      // marginBottom: 0.5,
                                      padding: 0.5,
                                      flexGrow: 1,
                                      marginRight: 1,
                                      alignItems: "center",
                                    }}
                                  >
                                    <span style={{ fontWeight: "bold" }}>
                                      In Flight Service
                                    </span>
                                  </Grid>
                                  <Grid
                                    // item
                                    xs={5.7}
                                    sx={{
                                      backgroundColor: "#EEEEEE",
                                      display: "flex",
                                      justifyContent: "space-between",
                                      // marginBottom: 0.5,
                                      padding: 0.5,
                                      flexGrow: 1,
                                      marginRight: 1,
                                      alignItems: "center",
                                    }}
                                  >
                                    <HorizontalRuleIcon
                                      sx={{ fontSize: "small" }}
                                    />
                                  </Grid>
                                </Grid>
                              </Grid>
                              {segment?.is_departed && (
                                <Grid
                                  sx={{
                                    textAlign: "right",
                                    color: "red",
                                    padding: 0.5,
                                    marginRight: 1,
                                    marginTop: 8,
                                  }}
                                >
                                  {segment.is_departed
                                    ? "Travel date has passed"
                                    : null}
                                </Grid>
                              )}
                            </>
                          ) : segment?.FlightDetails?.length > 0 ? (
                            segment?.FlightDetails?.map(
                              (flight_details, index) => {
                                return (
                                  <>
                                    <Grid
                                      sx={{
                                        height:
                                          segment?.FlightDetails?.length > 1
                                            ? "33%"
                                            : "60%",
                                      }}
                                    >
                                      <Grid
                                        sx={{
                                          display: "flex",
                                          flexWrap: "wrap",
                                          marginTop:
                                            segment?.FlightDetails?.length > 2
                                              ? 0
                                              : index > 0
                                                ? 9
                                                : 0,
                                          alignItems: "flex-start",
                                          height: isSmallScreen
                                            ? "17vh"
                                            : isMediumScreen
                                              ? "17vh"
                                              : "15vh",
                                        }}
                                      >
                                        <Grid
                                          // item
                                          xs={5.7}
                                          sx={{
                                            backgroundColor: "#EEEEEE",
                                            display: "flex",
                                            justifyContent: "space-between",
                                            // marginBottom: 0.5,
                                            padding: 0.5,
                                            flexGrow: 1,
                                            marginRight: 1,
                                          }}
                                        >
                                          <span style={{ fontWeight: "bold" }}>
                                            Status
                                          </span>
                                          <span>
                                            {segment.SegmentStatus ? (
                                              segment.SegmentStatus
                                            ) : (
                                              <HorizontalRuleIcon
                                                sx={{ fontSize: "small" }}
                                              />
                                            )}
                                          </span>
                                        </Grid>

                                        <Grid
                                          // item
                                          xs={5.7}
                                          sx={{
                                            backgroundColor: "#EEEEEE",
                                            display: "flex",
                                            justifyContent: "space-between",
                                            // marginBottom: 0.5,
                                            padding: 0.5,
                                            flexGrow: 1,
                                            marginRight: 1,
                                          }}
                                        >
                                          <span style={{ fontWeight: "bold" }}>
                                            Cabin
                                          </span>
                                          <span>
                                            {flight_details.Cabin ? (
                                              flight_details.Cabin
                                            ) : (
                                              <HorizontalRuleIcon
                                                sx={{ fontSize: "small" }}
                                              />
                                            )}
                                          </span>
                                        </Grid>

                                        <Grid
                                          // item
                                          xs={5.7}
                                          sx={{
                                            backgroundColor: "#EEEEEE",
                                            display: "flex",
                                            justifyContent: "space-between",
                                            // marginBottom: 0.5,
                                            padding: 0.5,
                                            flexGrow: 1,
                                            marginRight: 1,
                                          }}
                                        >
                                          <span style={{ fontWeight: "bold" }}>
                                            Booking Class
                                          </span>
                                          {filteredFields?.includes("BC") && (
                                            <span>
                                              {segment.BookingClass ? (
                                                segment.BookingClass
                                              ) : (
                                                <HorizontalRuleIcon
                                                  sx={{ fontSize: "small" }}
                                                />
                                              )}
                                            </span>
                                          )}
                                        </Grid>

                                        <Grid
                                          // item
                                          xs={5.7}
                                          sx={{
                                            backgroundColor: "#EEEEEE",
                                            display: "flex",
                                            justifyContent: "space-between",
                                            // marginBottom: 0.5,
                                            padding: 0.5,
                                            flexGrow: 1,
                                            marginRight: 1,
                                          }}
                                        >
                                          <span style={{ fontWeight: "bold" }}>
                                            Co2 emission
                                          </span>
                                          {filteredFields?.includes("Co2") &&
                                            flight_details.CO2Emission ? (
                                            <span>
                                              {flight_details?.CO2Emission}{" "}
                                              {flight_details?.Unit}
                                            </span>
                                          ) : (
                                            <HorizontalRuleIcon
                                              sx={{ fontSize: "small" }}
                                            />
                                          )}
                                        </Grid>
                                        <Grid
                                          // item
                                          xs={5.7}
                                          sx={{
                                            backgroundColor: "#EEEEEE",
                                            display: "flex",
                                            justifyContent: "space-between",
                                            // marginBottom: 0.5,
                                            padding: 0.5,
                                            flexGrow: 1,
                                            marginRight: 1,
                                            alignItems: "center",
                                          }}
                                        >
                                          <span style={{ fontWeight: "bold" }}>
                                            In Flight Service
                                          </span>
                                        </Grid>
                                        <Grid
                                          // item
                                          xs={5.7}
                                          sx={{
                                            backgroundColor: "#EEEEEE",
                                            display: "flex",
                                            justifyContent: "space-between",
                                            // marginBottom: 0.5,
                                            padding: 0.5,
                                            flexGrow: 1,
                                            marginRight: 1,
                                            alignItems: "center",
                                          }}
                                        >
                                          {flight_details.Meal ? (
                                            flight_details?.Meal?.map(
                                              (meal, index) => (
                                                <>
                                                  {meal}
                                                  {index <
                                                    flight_details.Meal.length -
                                                    1 && " & "}
                                                </>
                                              )
                                            )
                                          ) : (
                                            <HorizontalRuleIcon
                                              sx={{ fontSize: "small" }}
                                            />
                                          )}
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                    {segment?.is_departed && (
                                      <Grid
                                        sx={{
                                          textAlign: "right",
                                          color: "red",
                                          padding: 0.5,
                                          marginRight: 1,
                                        }}
                                      >
                                        {segment.is_departed
                                          ? "Travel date has passed"
                                          : null}
                                      </Grid>
                                    )}
                                  </>
                                );
                              }
                            )
                          ) : (
                            <>
                              <Grid
                                sx={{
                                  height:
                                    segment?.FlightDetails?.length > 1
                                      ? "33%"
                                      : "60%",
                                }}
                              >
                                <Grid
                                  sx={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    // marginTop:
                                    //   segment?.FlightDetails?.length > 2
                                    //     ? 0
                                    //     : segIndex > 0
                                    //     ? 9
                                    //     : 0,
                                    alignItems: "flex-start",
                                    height: isSmallScreen
                                      ? "17vh"
                                      : isMediumScreen
                                        ? "17vh"
                                        : "15vh",
                                  }}
                                >
                                  <Grid
                                    // item
                                    xs={5.7}
                                    sx={{
                                      backgroundColor: "#EEEEEE",
                                      display: "flex",
                                      justifyContent: "space-between",
                                      // marginBottom: 0.5,
                                      padding: 0.5,
                                      flexGrow: 1,
                                      marginRight: 1,
                                    }}
                                  >
                                    <span style={{ fontWeight: "bold" }}>
                                      Status
                                    </span>
                                    <span>
                                      {segment.SegmentStatus ? (
                                        segment.SegmentStatus
                                      ) : (
                                        <HorizontalRuleIcon
                                          sx={{ fontSize: "small" }}
                                        />
                                      )}
                                    </span>
                                  </Grid>

                                  <Grid
                                    // item
                                    xs={5.7}
                                    sx={{
                                      backgroundColor: "#EEEEEE",
                                      display: "flex",
                                      justifyContent: "space-between",
                                      // marginBottom: 0.5,
                                      padding: 0.5,
                                      flexGrow: 1,
                                      marginRight: 1,
                                    }}
                                  >
                                    <span style={{ fontWeight: "bold" }}>
                                      Cabin
                                    </span>
                                    <span>
                                      {segment.Cabin ? (
                                        segment.Cabin
                                      ) : (
                                        <HorizontalRuleIcon
                                          sx={{ fontSize: "small" }}
                                        />
                                      )}
                                    </span>
                                  </Grid>

                                  <Grid
                                    // item
                                    xs={5.7}
                                    sx={{
                                      backgroundColor: "#EEEEEE",
                                      display: "flex",
                                      justifyContent: "space-between",
                                      // marginBottom: 0.5,
                                      padding: 0.5,
                                      flexGrow: 1,
                                      marginRight: 1,
                                    }}
                                  >
                                    <span style={{ fontWeight: "bold" }}>
                                      Booking Class
                                    </span>
                                    {filteredFields?.includes("BC") && (
                                      <span>
                                        {segment.BookingClass ? (
                                          segment.BookingClass
                                        ) : (
                                          <HorizontalRuleIcon
                                            sx={{ fontSize: "small" }}
                                          />
                                        )}
                                      </span>
                                    )}
                                  </Grid>

                                  <Grid
                                    // item
                                    xs={5.7}
                                    sx={{
                                      backgroundColor: "#EEEEEE",
                                      display: "flex",
                                      justifyContent: "space-between",
                                      // marginBottom: 0.5,
                                      padding: 0.5,
                                      flexGrow: 1,
                                      marginRight: 1,
                                    }}
                                  >
                                    <span style={{ fontWeight: "bold" }}>
                                      Co2 emission
                                    </span>
                                    {filteredFields?.includes("Co2") &&
                                      segment.CO2Emission ? (
                                      <span>
                                        {segment?.CO2Emission} {segment?.Unit}
                                      </span>
                                    ) : (
                                      <HorizontalRuleIcon
                                        sx={{ fontSize: "small" }}
                                      />
                                    )}
                                  </Grid>
                                  <Grid
                                    // item
                                    xs={5.7}
                                    sx={{
                                      backgroundColor: "#EEEEEE",
                                      display: "flex",
                                      justifyContent: "space-between",
                                      // marginBottom: 0.5,
                                      padding: 0.5,
                                      flexGrow: 1,
                                      marginRight: 1,
                                      alignItems: "center",
                                    }}
                                  >
                                    <span style={{ fontWeight: "bold" }}>
                                      In Flight Service
                                    </span>
                                  </Grid>
                                  <Grid
                                    // item
                                    xs={5.7}
                                    sx={{
                                      backgroundColor: "#EEEEEE",
                                      display: "flex",
                                      justifyContent: "space-between",
                                      // marginBottom: 0.5,
                                      padding: 0.5,
                                      flexGrow: 1,
                                      marginRight: 1,
                                      alignItems: "center",
                                    }}
                                  >
                                    {segment.Meal ? (
                                      segment?.Meal?.map((meal, index) => (
                                        <>
                                          {meal}
                                          {index < segment.Meal.length - 1 &&
                                            " & "}
                                        </>
                                      ))
                                    ) : (
                                      <HorizontalRuleIcon
                                        sx={{ fontSize: "small" }}
                                      />
                                    )}
                                  </Grid>
                                </Grid>
                              </Grid>
                              {segment?.is_departed && (
                                <Grid
                                  sx={{
                                    textAlign: "right",
                                    color: "red",
                                    padding: 0.5,
                                    marginRight: 1,
                                    marginTop: 3,
                                  }}
                                >
                                  {segment.is_departed
                                    ? "Travel date has passed"
                                    : null}
                                </Grid>
                              )}
                            </>
                          )}
                        </Grid>
                      </Grid>
                    </Grid>
                    {segment?.Duration && (
                      <Grid
                        sx={{
                          marginBottom: 2,
                          padding: 1,
                          boxShadow: "inset 0 -1px 0 0 #F1EEE9",
                        }}
                      >
                        <Grid xs={12} sx={{ textAlign: "center" }}>
                          <Typography sx={{ fontSize: 18, fontWeight: "bold" }}>
                            {segment?.FlightDetails?.length > 1
                              ? `----------Stopover: ${segment.Duration} in ${segment?.FlightDetails[
                                segment?.FlightDetails?.length - 1
                              ]?.ToCity
                              }----------`
                              : `----------Stopover: ${segment.Duration} in ${segment?.ToCity}----------`}
                          </Typography>
                        </Grid>
                      </Grid>
                    )}
                  </Grid>
                );
              })}
            </Grid>

            {bookingTravelerOtherInfo?.length > 0 &&
              bookingTravelerOtherInfo?.some(
                (item) => item?.OtherInfo?.length > 0
              ) && (
                <Grid container sx={{ marginTop: 1, marginBottom: "1.5%" }}>
                  <Grid
                    xs={12}
                    sx={{
                      backgroundColor: "#3e3b39",
                      color: "white",
                      height: "4vh",
                      padding: 1,
                      fontSize: 18,
                      textTransform: "uppercase",
                    }}
                  >
                    Passenger's other details
                  </Grid>
                  <Grid
                    container
                    sx={{
                      marginTop: 1,
                      backgroundColor: "#d8d9da",
                      height: "4vh",
                      padding: 1,
                      fontSize: 18,
                    }}
                  >
                    <Grid xs={3}>Last Name/First Name</Grid>
                    <Grid xs={2}>Origin/Destination</Grid>
                    <Grid xs={2}>Seat Number</Grid>
                    <Grid xs={1.5}>Baggage</Grid>
                    <Grid xs={2}>Meal Preference</Grid>
                    <Grid xs={1.5}>Wheelchair</Grid>
                  </Grid>
                  {bookingTravelerOtherInfo
                    ?.slice(0, visibleCount)
                    ?.map((item) => {
                      return (
                        <Grid
                          container
                          sx={{
                            margin: 1,
                            padding: theme.spacing(0.2),
                          }}
                        >
                          <Grid xs={3}>
                            <Typography>{item?.Name}</Typography>
                          </Grid>
                          <Grid xs={2}>
                            {item?.OtherInfo?.map((value, index) => (
                              <Typography>
                                {value?.From} - {value?.To}
                              </Typography>
                            ))}
                          </Grid>
                          <Grid xs={2}>
                            {item?.OtherInfo?.map((value, index) => (
                              <Typography>
                                {value.Seat ? (
                                  value?.Seat
                                ) : (
                                  <HorizontalRuleIcon
                                    sx={{ fontSize: "small" }}
                                  />
                                )}
                              </Typography>
                            ))}
                          </Grid>
                          <Grid xs={1.5}>
                            {item?.OtherInfo?.map((value, index) => (
                              <Typography>
                                {value.BaggageAllowance ? (
                                  value?.BaggageAllowance
                                ) : (
                                  <HorizontalRuleIcon
                                    sx={{ fontSize: "small" }}
                                  />
                                )}
                              </Typography>
                            ))}
                          </Grid>
                          <Grid xs={2}>
                            {item?.OtherInfo?.map((value, index) => (
                              <Typography>
                                {value.MealPreference?.length > 0 ? (
                                  value?.MealPreference?.map(
                                    (item) => `${item}  `
                                  )
                                ) : (
                                  <HorizontalRuleIcon
                                    sx={{ fontSize: "small" }}
                                  />
                                )}
                              </Typography>
                            ))}
                          </Grid>
                          <Grid xs={1.5}>
                            {item?.OtherInfo?.map((value, index) => (
                              <Typography>
                                {value.Wheelchair ? (
                                  value.Wheelchair
                                ) : (
                                  <HorizontalRuleIcon
                                    sx={{ fontSize: "small" }}
                                  />
                                )}
                              </Typography>
                            ))}
                          </Grid>
                        </Grid>
                      );
                    })}
                </Grid>
              )}
          </>
        )}

        {/* {filteredFields?.includes("Fare") && totalPriceOfAllTickets > 0 ? (
          <Grid container sx={{ marginTop: 1 }}>
            <Grid
              xs={12}
              sx={{
                backgroundColor: "#3e3b39",
                color: "white",
                height: "4vh",
                padding: 1,
                fontSize: 18,
                textTransform: "uppercase",
              }}
            >
              Passenger fare and taxes details
            </Grid>
            <Grid
              container
              sx={{
                marginTop: 1,
                backgroundColor: "#d8d9da",
                height: "4vh",
                padding: 1,
                fontSize: 18,
              }}
            >
              <Grid xs={2}>No. of Passenger</Grid>
              <Grid xs={2}>Passenger Type</Grid>
              <Grid xs={2}>Fare</Grid>
              <Grid xs={2}>Taxes</Grid>
              <Grid xs={4}>Total Amount</Grid>
            </Grid>
            {bookingTraveler?.map((item) => {
              const isFirstOfType = !displayedPassengerTypes.has(
                item?.PassengerType
              );

              if (isFirstOfType) {
                displayedPassengerTypes.add(item?.PassengerType);
              }
              const fare =
                passengerData[item?.Key]?.fare || item?.BasePrice || null;
              const taxes =
                passengerData[item?.Key]?.taxes || item?.Taxes || null;

              return (
                isFirstOfType && (
                  <Grid
                    container
                    sx={{
                      margin: 0.8,
                      padding: theme.spacing(0.5),
                    }}
                  >
                    <Grid container>
                      <Grid xs={2}>{passengerCounts[item?.PassengerType]}</Grid>
                      <Grid xs={2}>{item?.PassengerType}</Grid>
                      <Grid xs={2}>
                        <StyledTextField
                          sx={{ marginRight: 2 }}
                          value={fare}
                          onChange={(e) => {
                            const value = e.target.value.replace(
                              /[^0-9.]/g,
                              ""
                            );
                            handleFareChange(item?.Key, value);
                          }}
                          variant="outlined"
                          inputProps={{ style: { padding: 0 } }}
                        />
                      </Grid>
                      <Grid xs={2}>
                        <StyledTextField
                          sx={{ marginRight: 2 }}
                          value={taxes}
                          onChange={(e) => {
                            const value = e.target.value.replace(
                              /[^0-9.]/g,
                              ""
                            );
                            handleTaxesChange(item?.Key, value);
                          }}
                          variant="outlined"
                          inputProps={{ style: { padding: 0 } }}
                        />
                      </Grid>
                      <Grid xs={4} sx={{ marginTop: 0.8 }}>
                        {(Number(fare) + Number(taxes))?.toFixed(2)}
                      </Grid>
                    </Grid>
                    {filteredFields?.includes("TaxBreakdown") &&
                      item.tax_info && (
                        <Grid container sx={{ marginTop: 2, marginBottom: 2 }}>
                          <Grid xs={3}></Grid>
                          <Grid xs={1} sx={{ fontWeight: "bold" }}>
                            Tax Breakdown
                          </Grid>
                          <Grid xs={8}>{item?.tax_info}</Grid>
                        </Grid>
                      )}
                  </Grid>
                )
              );
            })}
            <Grid
              container
              sx={{
                display: "flex",
                justifyContent: "right",
                margin: 0.8,
              }}
            >
              <Grid
                xs={3}
                sx={{
                  marginRight: 1,
                  textAlign: "right",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <Typography sx={{ fontSize: 20, fontWeight: "bold" }}>
                  Total (in {currency})
                </Typography>
                <Typography sx={{ fontSize: 20, fontWeight: "bold" }}>
                  {totalPriceOfAllTickets}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        ) : null} */}
        {filteredFields?.includes("Fare") && airPricing?.length > 0 ? (
          <Grid container sx={{ marginTop: 1 }}>
            <Grid
              xs={12}
              sx={{
                backgroundColor: "#3e3b39",
                color: "white",
                height: "4vh",
                padding: 1,
                fontSize: 18,
                textTransform: "uppercase",
              }}
            >
              Passenger fare and taxes details
            </Grid>
            <Grid
              container
              sx={{
                marginTop: 1,
                backgroundColor: "#d8d9da",
                height: "4vh",
                padding: 1,
                fontSize: 18,
              }}
            >
              <Grid xs={2}>No. of Passenger</Grid>
              <Grid xs={2}>Passenger Type</Grid>
              <Grid xs={2}>Fare</Grid>
              <Grid xs={2}>Taxes</Grid>
              <Grid xs={4}>Total Amount</Grid>
            </Grid>

            {airPricing.map((item, idx) => (
              <Grid
                container
                key={idx}
                sx={{
                  margin: 0.8,
                  padding: theme.spacing(0.5),
                }}
              >
                <Grid container>
                  <Grid xs={2}>
                    {passengerCounts[item?.PassengerTypeCode] || 1}
                  </Grid>
                  <Grid xs={2}>{item?.PassengerType}</Grid>
                  <Grid xs={2}>
                    <StyledTextField
                      sx={{ marginRight: 2 }}
                      value={item?.BasePrice || ""}
                      onChange={(e) => {
                            const updated = [...airPricing];
                            updated[idx] = {
                              ...updated[idx],
                              BasePrice: e.target.value,
                            };
                            setAirPricing(updated); // <-- update state
                          }}
                      variant="outlined"
                      inputProps={{ style: { padding: 0 } }}
                    />
                  </Grid>
                  <Grid xs={2}>
                    <StyledTextField
                      sx={{ marginRight: 2 }}
                      value={item?.Taxes || ""}
                      onChange={(e) => {
                            const updated = [...airPricing];
                            updated[idx] = {
                              ...updated[idx],
                              Taxes: e.target.value,
                            };
                            setAirPricing(updated); // <-- update state
                          }}
                      variant="outlined"
                      inputProps={{ style: { padding: 0 } }}
                    />
                  </Grid>
                  <Grid xs={4} sx={{ marginTop: 0.8 }}>
                    {item?.TotalPrice}
                  </Grid>
                </Grid>

                {filteredFields?.includes("TaxBreakdown") && item?.tax_info && (
                  <Grid container sx={{ marginTop: 2, marginBottom: 2 }}>
                    <Grid xs={3}></Grid>
                    <Grid xs={1} sx={{ fontWeight: "bold" }}>
                      Tax Breakdown
                    </Grid>
                    <Grid xs={8}>{item?.tax_info}</Grid>
                  </Grid>
                )}

                {filteredFields?.includes("Endorsement") &&
                  getEndorsementText(item) && (
                    <Grid container sx={{ marginTop: 0, marginBottom: 2 }}>
                      <Grid xs={3}></Grid>
                      <Grid xs={1} sx={{ fontWeight: "bold" }}>
                        Endorsement
                      </Grid>
                      <Grid xs={8}>{getEndorsementText(item)}</Grid>
                    </Grid>
                  )}
              </Grid>
            ))}


            <Grid
              container
              sx={{
                display: "flex",
                justifyContent: "right",
                margin: 0.8,
              }}
            >
            <Grid
  container
  sx={{
    display: "flex",
    justifyContent: "right",
    margin: 0.8,
  }}
>
  <Grid
    xs={6}
    sx={{
      marginRight: 1,
      textAlign: "right",
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-end",
      alignItems: "flex-end",
      gap: 1,
    }}
  >
    {(() => {
      // Recalculate totals by currency when fare/taxes are changed
      const totalsByCurrency = airPricing.reduce((acc, item) => {
        const match = item?.TotalPrice?.match(/^([A-Z]+)([\d.]+)$/);

        if (match) {
          const [, curr] = match;

          // Ensure numeric values from editable fields
          const base = Number(item?.BasePrice?.replace(/[^\d.]/g, "")) || 0;
          const tax = Number(item?.Taxes?.replace(/[^\d.]/g, "")) || 0;
          const passengerCount = passengerCounts[item?.PassengerTypeCode] || 1;

          // Compute total dynamically instead of using stale item.TotalPrice
          const amount = (base + tax) * passengerCount;

          acc[curr] = (acc[curr] || 0) + amount;
        }
        return acc;
      }, {});

      return Object.entries(totalsByCurrency).map(([curr, total]) => (
        <Typography key={curr} sx={{ fontSize: 20, fontWeight: "bold" }}>
          Total (in {curr}) {total.toFixed(2)}
        </Typography>
      ));
    })()}
  </Grid>
</Grid>

            </Grid>

          </Grid>
        ) : null}


        {filteredFields?.includes("OptionalService") &&
          extraCharges?.length > 0 ? (
          <Grid container sx={{ marginTop: 3 }}>
            <Grid
              xs={12}
              sx={{
                backgroundColor: "#3e3b39",
                color: "white",
                height: "4vh",
                padding: 1,
                fontSize: 18,
                textTransform: "uppercase",
              }}
            >
              Optional Services
            </Grid>
            <Grid
              container
              sx={{
                marginTop: 1,
                backgroundColor: "#d8d9da",
                height: "4vh",
                padding: 1,
                fontSize: 18,
              }}
            >
              <Grid xs={2}>Optional Services</Grid>
              <Grid xs={4}>Passenger Name</Grid>
              <Grid xs={2}>EMD Number</Grid>
              <Grid xs={2}>Total Cost</Grid>
              <Grid xs={2}>Add. Charges</Grid>
            </Grid>
            {extraCharges?.map((item, index) => {
              return (
                <Grid
                  container
                  sx={{
                    margin: 0.8,
                    padding: theme.spacing(0.5),
                  }}
                >
                  <Grid container>
                    <Grid xs={2}>
                      <StyledTextField
                        fullWidth
                        value={item?.OptionalService}
                        onChange={(e) => {
                          const value = e.target.value;
                          handleExtraChargesDataChange(
                            index,
                            "OptionalService",
                            value || ""
                          );
                        }}
                        variant="outlined"
                        inputProps={{
                          style: {
                            padding: 0,
                          },
                        }}
                      />
                    </Grid>
                    <Grid xs={4}>{item?.PassengerName}</Grid>
                    <Grid xs={2}>
                      {item.EMDNumber ? (
                        item.EMDNumber
                      ) : (
                        <HorizontalRuleIcon sx={{ fontSize: "small" }} />
                      )}
                    </Grid>
                    <Grid xs={2}>
                      <StyledTextField
                        sx={{ marginRight: 2 }}
                        value={item.TotalCost}
                        onChange={(e) => {
                          const value = e.target.value.replace(/[^0-9.]/g, "");
                          handleExtraChargesDataChange(
                            index,
                            "TotalCost",
                            value
                          );
                        }}
                        variant="outlined"
                        inputProps={{ style: { padding: 0 } }}
                      />
                    </Grid>
                    <Grid xs={2}>
                      <StyledTextField
                        sx={{ marginRight: 2 }}
                        value={item?.ExchangeTotalPrice}
                        onChange={(e) => {
                          const value = e.target.value.replace(/[^0-9.]/g, "");
                          handleExtraChargesDataChange(
                            index,
                            "ExchangeTotalPrice",
                            value
                          );
                        }}
                        variant="outlined"
                        inputProps={{ style: { padding: 0 } }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              );
            })}
            <Grid
              container
              sx={{
                display: "flex",
                justifyContent: "right",
                margin: 0.8,
              }}
            >
              <Grid
                xs={3}
                sx={{
                  marginRight: 1,
                  textAlign: "right",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <Typography sx={{ fontSize: 20, fontWeight: "bold" }}>
                  Total (in {currency})
                </Typography>
                <Typography sx={{ fontSize: 20, fontWeight: "bold" }}>
                  {extraChargesTotalPrice}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        ) : null}

        {filteredFields?.includes("Service") && (
          <Grid container sx={{ marginTop: 3 }}>
            <Grid
              xs={12}
              sx={{
                backgroundColor: "#3e3b39",
                color: "white",
                height: "4vh",
                padding: 1,
                fontSize: 18,
                textTransform: "uppercase",
              }}
            >
              Add Service Fees
            </Grid>
            <Grid
              container
              sx={{
                marginTop: 1,
                backgroundColor: "#d8d9da",
                height: "4vh",
                padding: 1,
                fontSize: 18,
              }}
            >
              <Grid xs={1}>
                <Button
                  size="small"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "black",
                    height: "100%",
                  }}
                  onClick={handleAddService}
                >
                  <AddIcon />
                </Button>
              </Grid>
              <Grid xs={6}>Type of Service</Grid>
              <Grid xs={5}>Fees</Grid>
            </Grid>
            {services.map((service, index) => (
              <Grid container key={index} sx={{ margin: 0.8, padding: 0.5 }}>
                <Grid xs={1}>
                  <Button
                    disabled={services.length == 1}
                    size="small"
                    onClick={() => handleRemoveService(index)}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "black",
                      height: "100%",
                    }}
                  >
                    <DeleteIcon />
                  </Button>
                </Grid>
                <Grid xs={6} sx={{ margin: 0 }}>
                  <StyledTextField
                    sx={{ marginRight: 2, width: "50%" }}
                    value={service.type}
                    onChange={(e) =>
                      handleServiceChange(index, "type", e.target.value)
                    }
                    variant="outlined"
                    inputProps={{ style: { padding: 0 } }}
                  />
                </Grid>
                <Grid xs={5} sx={{ margin: 0 }}>
                  <StyledTextField
                    sx={{ marginRight: 2, width: "30%" }}
                    value={service.fee}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9.]/g, "");
                      handleServiceChange(index, "fee", value);
                    }}
                    variant="outlined"
                    inputProps={{ style: { padding: 0 } }}
                  />
                </Grid>
              </Grid>
            ))}

            <Grid
              container
              sx={{
                display: "flex",
                justifyContent: "right",
                margin: 0.8,
              }}
            >
              <Grid
                xs={3}
                sx={{
                  marginRight: 1,
                  textAlign: "right",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <Typography sx={{ fontSize: 20, fontWeight: "bold" }}>
                  Total (in {currency})
                </Typography>
                <Typography sx={{ fontSize: 20, fontWeight: "bold" }}>
                  {totalServiceFees}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        )}

        {filteredFields.includes("FareCal") &&
          bookingTraveler?.some((item) => item?.fare_calc) && (
            <Grid container sx={{ marginTop: 2 }}>
              <Grid
                xs={12}
                sx={{
                  backgroundColor: "#3e3b39",
                  color: "white",
                  height: "4vh",
                  padding: 1,
                  fontSize: 18,
                  textTransform: "uppercase",
                }}
              >
                Fare Calculations
              </Grid>
              {bookingTraveler?.map((item) => {
                const isFirstOfType = !displayedPassengerTypesFareCalc.has(
                  item?.PassengerType
                );

                if (isFirstOfType) {
                  displayedPassengerTypesFareCalc.add(item?.PassengerType);
                }
                return (
                  isFirstOfType && (
                    <Grid
                      container
                      sx={{
                        marginTop: 1,
                        height: "4vh",
                        padding: 1,
                        fontSize: 18,
                      }}
                    >
                      <Grid xs={2}>{item?.PassengerType}</Grid>
                      <Grid xs={10}>{item?.fare_calc}</Grid>
                    </Grid>
                  )
                );
              })}
            </Grid>
          )}

        {filteredFields.includes("Baggage") ? (
          itinerary_data?.baggage_allowance?.length > 0 ||
            itinerary_data?.carry_on_allowance_info?.length > 0 ? (
            <Grid container sx={{ marginTop: 2 }}>
              <Grid
                xs={12}
                sx={{
                  backgroundColor: "#3e3b39",
                  color: "white",
                  height: "4vh",
                  padding: 1,
                  fontSize: 18,
                  textTransform: "uppercase",
                }}
              >
                Baggage and carry on allowance
              </Grid>
              {itinerary_data?.baggage_allowance?.length > 0 && (
                <>
                  <Grid
                    container
                    sx={{
                      marginTop: 1,
                      // backgroundColor: "#f5f5f5",
                      height: "4vh",
                      padding: 1,
                      fontSize: 18,
                    }}
                  >
                    <Grid xs={12} sx={{ fontWeight: "bold" }}>
                      Baggage Allowance
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    sx={{
                      // marginTop: 1,
                      backgroundColor: "#d8d9da",
                      height: "4vh",
                      padding: 1,
                      fontSize: 18,
                    }}
                  >
                    <Grid xs={1.5}>Passenger Type</Grid>
                    <Grid xs={1.5}>Origin/Destination</Grid>
                    <Grid xs={5}>Baggage</Grid>
                    <Grid xs={3.5}>Information</Grid>
                  </Grid>
                  {travelerTypeOrder?.map((travelerType) => {
                    return displayBaggage[travelerType].length > 0 ? (
                      <>
                        <Grid
                          container
                          sx={{
                            marginTop: 1,
                            backgroundColor: "#f5f5f5",
                            height: "4vh",
                            padding: 1,
                            fontSize: 18,
                          }}
                        >
                          <Grid xs={12}>{travelerType}</Grid>
                        </Grid>
                        {displayBaggage[travelerType]?.map((item, index) => {
                          const isFirstOfItsKind =
                            index === 0 ||
                            displayBaggage[travelerType][index - 1].From !==
                            item.From ||
                            displayBaggage[travelerType][index - 1].To !==
                            item.To;

                          return (
                            isFirstOfItsKind && (
                              <Grid
                                container
                                key={`${travelerType}-${index}`}
                                sx={{
                                  margin: 0.8,
                                  padding: theme.spacing(0.5),
                                  borderBottom:
                                    index ===
                                      displayBaggage[travelerType].length
                                      ? "1px solid #ddd"
                                      : "",
                                }}
                              >
                                <Grid xs={1.5}></Grid>
                                <Grid
                                  xs={1.5}
                                >{`${item.From} - ${item.To}`}</Grid>
                                <Grid xs={5}>
                                  <Typography>
                                    {item?.baggage?.map((bag, index) => (
                                      <>
                                        <span
                                          style={{
                                            fontWeight: "bold",
                                            marginLeft: index > 0 ? 10 : 0,
                                          }}
                                        >
                                          {index + 1 === 1
                                            ? "1st"
                                            : index + 1 === 2
                                              ? "2nd"
                                              : index + 1 === 3
                                                ? "3rd"
                                                : `${index + 1}th`}{" "}
                                          Checked Bag:
                                        </span>
                                        <span>{bag[0]}</span>
                                        {index !==
                                          item?.baggage?.length - 1 && (
                                            <span>,</span>
                                          )}
                                      </>
                                    ))}
                                  </Typography>
                                </Grid>
                                <Grid xs={3.5}>
                                  <Typography
                                    sx={{ textTransform: "capitalize" }}
                                  >
                                    {item.baggage_info[2]}
                                  </Typography>
                                </Grid>
                              </Grid>
                            )
                          );
                        })}
                      </>
                    ) : null;
                  })}
                </>
              )}

              {itinerary_data?.carry_on_allowance_info?.length > 0 && (
                <>
                  <Grid
                    container
                    sx={{
                      marginTop: 1,
                      height: "4vh",
                      padding: 1,
                      fontSize: 18,
                    }}
                  >
                    <Grid xs={12} sx={{ fontWeight: "bold", marginTop: 2 }}>
                      Carry On Allowance
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    sx={{
                      marginTop: 2,
                      backgroundColor: "#d8d9da",
                      height: "4vh",
                      padding: 1,
                      fontSize: 18,
                    }}
                  >
                    <Grid xs={3}>Origin/Destination</Grid>
                    <Grid xs={3}>Baggage</Grid>
                    {/* <Grid xs={2}>1st bag</Grid>
              <Grid xs={2}>2nd bag</Grid> */}
                    <Grid xs={6}>Information</Grid>
                  </Grid>
                  {itinerary_data?.carry_on_allowance_info?.map((item) => {
                    return (
                      <Grid
                        container
                        sx={{
                          margin: 0.8,
                          padding: theme.spacing(0.5),
                          // boxShadow: "inset 0 -1px 0 0 #F1EEE9",
                        }}
                      >
                        <Grid xs={3}>{`${item?.From} - ${item?.To}`}</Grid>
                        <Grid xs={3}>{item?.carry_on?.[0]}</Grid>
                        <Grid xs={6}>{item?.carry_on?.[1]}</Grid>
                      </Grid>
                    );
                  })}
                </>
              )}
            </Grid>
          ) : null
        ) : null}

        <Grid container>
          {filteredFields.includes("Hotel") &&
            itinerary_data?.hotel_info?.length > 0 ? (
            <>
              <Grid container sx={{ marginTop: 2 }}>
                <Grid
                  xs={12}
                  sx={{
                    backgroundColor: "#3e3b39",
                    color: "white",
                    height: "4vh",
                    padding: 1,
                    fontSize: 18,
                    textTransform: "uppercase",
                  }}
                >
                  Hotel Details
                </Grid>
              </Grid>
              <Grid
                container
                sx={{
                  marginTop: 1,
                  backgroundColor: "#d8d9da",
                  height: "4vh",
                  padding: 1,
                  fontSize: 18,
                }}
              >
                <Grid xs={2.5}>Name</Grid>
                <Grid xs={2}>Address</Grid>
                <Grid xs={7.5}>Other Information</Grid>
              </Grid>
              {itinerary_data?.hotel_info?.map((item, index) => {
                return (
                  <Grid
                    container
                    sx={{
                      margin: 0.8,
                      padding: theme.spacing(0.5),
                      // boxShadow: "inset 0 -1px 0 0 #F1EEE9",
                    }}
                  >
                    <Grid xs={2.5}>{item?.Name}</Grid>
                    <Grid xs={2}>
                      {item?.Address?.map((item) => (
                        <Typography>{item}</Typography>
                      ))}
                    </Grid>
                    <Grid xs={7.5}>
                      <Grid
                        sx={{
                          display: "flex",
                          flexWrap: "wrap",
                          marginTop: index > 0 ? 7 : 0,
                          alignItems: "flex-start",
                          height: "16vh",
                        }}
                      >
                        <Grid
                          xs={3.6}
                          sx={{
                            backgroundColor: "#EEEEEE",
                            display: "flex",
                            justifyContent: "space-between",
                            marginRight: 1,
                            padding: 0.5,
                            flexGrow: 1,
                          }}
                        >
                          <span style={{ fontWeight: "bold" }}>Check-in </span>
                          {item?.CheckIn}
                        </Grid>
                        <Grid
                          xs={3.6}
                          sx={{
                            backgroundColor: "#EEEEEE",
                            display: "flex",
                            justifyContent: "space-between",
                            marginRight: 1,
                            padding: 0.5,
                            flexGrow: 1,
                          }}
                        >
                          <span style={{ fontWeight: "bold" }}>Check-out</span>
                          {item?.CheckOut}
                        </Grid>
                        <Grid
                          xs={3.6}
                          sx={{
                            backgroundColor: "#EEEEEE",
                            display: "flex",
                            justifyContent: "space-between",
                            marginRight: 1,
                            padding: 0.5,
                            flexGrow: 1,
                          }}
                        >
                          <span style={{ fontWeight: "bold" }}>Room(s) </span>
                          {item?.Rooms}
                        </Grid>
                        <Grid
                          xs={3.6}
                          sx={{
                            backgroundColor: "#EEEEEE",
                            display: "flex",
                            justifyContent: "space-between",
                            marginRight: 1,
                            padding: 0.5,
                            flexGrow: 1,
                          }}
                        >
                          <span style={{ fontWeight: "bold" }}>Nights </span>
                          {item?.Nights}
                        </Grid>
                        <Grid
                          xs={3.6}
                          sx={{
                            backgroundColor: "#EEEEEE",
                            display: "flex",
                            justifyContent: "space-between",
                            marginRight: 1,
                            padding: 0.5,
                            flexGrow: 1,
                          }}
                        >
                          <span style={{ fontWeight: "bold" }}>Person(s) </span>
                          {item?.Persons}
                        </Grid>
                        <Grid
                          xs={3.6}
                          sx={{
                            backgroundColor: "#EEEEEE",
                            display: "flex",
                            justifyContent: "space-between",
                            marginRight: 1,
                            padding: 0.5,
                            flexGrow: 1,
                          }}
                        >
                          <span style={{ fontWeight: "bold" }}>Status </span>
                          {item?.Status}
                        </Grid>
                        <Grid
                          xs={3.6}
                          sx={{
                            backgroundColor: "#EEEEEE",
                            display: "flex",
                            justifyContent: "space-between",
                            marginRight: 1,
                            padding: 0.5,
                            flexGrow: 1,
                          }}
                        >
                          <span style={{ fontWeight: "bold" }}>
                            Confirmation Number
                          </span>
                          {item?.ConfirmationNumber}
                        </Grid>
                        <Grid
                          xs={3.6}
                          sx={{
                            backgroundColor: "#EEEEEE",
                            display: "flex",
                            justifyContent: "space-between",
                            marginRight: 1,
                            padding: 0.5,
                            flexGrow: 1,
                          }}
                        >
                          <span style={{ fontWeight: "bold" }}>
                            Phone Number
                          </span>
                          {item?.PhoneNumberHotel}
                        </Grid>
                        <Grid
                          xs={3.6}
                          sx={{
                            backgroundColor: "#EEEEEE",
                            display: "flex",
                            justifyContent: "space-between",
                            marginRight: 1,
                            padding: 0.5,
                            flexGrow: 1,
                          }}
                        >
                          <span style={{ fontWeight: "bold" }}>Fax Number</span>
                          {item?.PhoneNumberFax}
                        </Grid>
                        <Grid
                          xs={3.6}
                          sx={{
                            backgroundColor: "#EEEEEE",
                            display: "flex",
                            justifyContent: "space-between",
                            marginRight: 1,
                            padding: 0.5,
                            flexGrow: 1,
                          }}
                        >
                          <span style={{ fontWeight: "bold" }}>
                            Cancel Dead Line
                          </span>
                          {item?.CancelDeadLine}
                        </Grid>
                        <Grid
                          xs={3.6}
                          sx={{
                            backgroundColor: "#EEEEEE",
                            display: "flex",
                            justifyContent: "space-between",
                            marginRight: 1,
                            padding: 0.5,
                            flexGrow: 1,
                          }}
                        >
                          <span style={{ fontWeight: "bold" }}>
                            Rate Plan Type
                          </span>
                          {item?.RatePlanType}
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                );
              })}
              <Grid
                container
                sx={{
                  marginTop: 1,
                  backgroundColor: "#d8d9da",
                  height: "4vh",
                  padding: 1,
                  fontSize: 18,
                }}
              >
                <Grid xs={4}>Passenger</Grid>
                {/* <Grid xs={2}>Cost</Grid>
                <Grid xs={2}>Tax</Grid> */}
                {/* <Grid xs={3}>Tax</Grid> */}
                <Grid xs={6}>Total Cost</Grid>
              </Grid>
              {itinerary_data?.hotel_info?.map((item) => {
                return (
                  <>
                    <Grid
                      container
                      sx={{
                        margin: 0.8,
                        padding: theme.spacing(0.5),
                      }}
                    >
                      <Grid xs={4}>{item?.PassengerName}</Grid>
                      <Grid xs={6}>
                        <StyledTextField
                          value={hotelTotal}
                          onChange={(e) => setHotelTotal(e.target.value)}
                          sx={{ width: "30%" }}
                          variant="outlined"
                          inputProps={{
                            style: {
                              padding: 0,
                            },
                          }}
                        />
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      sx={{
                        display: "flex",
                        justifyContent: "right",
                        margin: 0.8,
                      }}
                    >
                      <Grid
                        xs={3}
                        sx={{
                          marginRight: 1,
                          textAlign: "right",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          gap: 1,
                        }}
                      >
                        <Typography sx={{ fontSize: 20, fontWeight: "bold" }}>
                          Total (in {item?.Rate?.substring(0, 3)})
                        </Typography>
                        <Typography sx={{ fontSize: 20, fontWeight: "bold" }}>
                          {hotelTotal}
                        </Typography>
                        {/* <StyledTextField
                        value={hotelTotal}
                        onChange={(e) => setHotelTotal(e.target.value)}
                        sx={{ width: "7%" }}
                        variant="outlined"
                        inputProps={{
                          style: {
                            padding: 0,
                            fontSize: 20,
                            fontWeight: "bold",
                          },
                        }}
                      /> */}
                      </Grid>
                    </Grid>
                  </>
                );
              })}
            </>
          ) : null}
        </Grid>
        <Grid container>
          {filteredFields?.includes("Vehicle") &&
            itinerary_data?.vehicle_info?.length > 0 ? (
            <>
              <Grid container sx={{ marginTop: 2 }}>
                <Grid
                  xs={12}
                  sx={{
                    backgroundColor: "#3e3b39",
                    color: "white",
                    height: "4vh",
                    padding: 1,
                    fontSize: 18,
                    textTransform: "uppercase",
                  }}
                >
                  Vehicle Details
                </Grid>
                <Grid
                  container
                  sx={{
                    marginTop: 1,
                    backgroundColor: "#d8d9da",
                    height: "4vh",
                    padding: 1,
                    fontSize: 18,
                  }}
                >
                  <Grid xs={2}>Name</Grid>
                  <Grid xs={2.5}>Pickup DateTime/Location</Grid>
                  <Grid xs={2.5}>Return DateTime/Location</Grid>
                  <Grid xs={5}>Other Information</Grid>
                </Grid>
              </Grid>
              {itinerary_data?.vehicle_info?.map((item, index) => {
                return (
                  <Grid
                    container
                    sx={{
                      margin: 0.8,
                      padding: theme.spacing(0.5),
                    }}
                  >
                    <Grid xs={2}>{item?.vendorName}</Grid>
                    <Grid xs={2.5}>
                      <Typography>{item?.pickupDateTime}</Typography>
                      <Typography>{item?.pickupLocation}</Typography>
                      <Typography>
                        {item?.pickupLocationType}-{item?.pickupLocationNumber}
                      </Typography>
                    </Grid>
                    <Grid xs={2.5}>
                      <Typography>{item?.returnDateTime}</Typography>
                      <Typography>{item?.pickupLocation}</Typography>
                      <Typography>
                        {item?.pickupLocationType}-{item?.pickupLocationNumber}
                      </Typography>
                    </Grid>
                    <Grid xs={5}>
                      <Grid
                        sx={{
                          display: "flex",
                          flexWrap: "wrap",
                          marginTop: index > 0 ? 7 : 0,
                          alignItems: "flex-start",
                          height: "7vh",
                        }}
                      >
                        <Grid
                          xs={5}
                          sx={{
                            backgroundColor: "#EEEEEE",
                            display: "flex",
                            justifyContent: "space-between",
                            padding: 0.5,
                            flexGrow: 1,
                            marginRight: 1,
                          }}
                        >
                          <span style={{ fontWeight: "bold" }}>
                            Air Conditioning
                          </span>
                          {item?.airConditioning ? "Included" : "Not Included"}
                        </Grid>
                        <Grid
                          xs={5}
                          sx={{
                            backgroundColor: "#EEEEEE",
                            display: "flex",
                            justifyContent: "space-between",
                            padding: 0.5,
                            flexGrow: 1,
                            marginRight: 1,
                          }}
                        >
                          <span style={{ fontWeight: "bold" }}>
                            Transmission Type
                          </span>
                          {item?.transmissionType}
                        </Grid>
                        <Grid
                          xs={5}
                          sx={{
                            backgroundColor: "#EEEEEE",
                            display: "flex",
                            justifyContent: "space-between",
                            padding: 0.5,
                            flexGrow: 1,
                            marginRight: 1,
                          }}
                        >
                          <span style={{ fontWeight: "bold" }}>
                            Vehicle Class
                          </span>
                          {item?.vehicleClass}
                        </Grid>
                        <Grid
                          xs={5}
                          sx={{
                            backgroundColor: "#EEEEEE",
                            display: "flex",
                            justifyContent: "space-between",
                            padding: 0.5,
                            flexGrow: 1,
                            marginRight: 1,
                          }}
                        >
                          <span style={{ fontWeight: "bold" }}>Category</span>
                          {item?.category}
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                );
              })}
              <Grid
                container
                sx={{
                  marginTop: 1,
                  backgroundColor: "#d8d9da",
                  height: "4vh",
                  padding: 1,
                  fontSize: 18,
                }}
              >
                <Grid xs={4}>Passenger</Grid>
                {/* <Grid xs={2}>Cost</Grid>
                <Grid xs={2}>Tax</Grid> */}
                {/* <Grid xs={3}>Tax</Grid> */}
                <Grid xs={6}>Total Cost</Grid>
              </Grid>
              {itinerary_data?.vehicle_info?.map((item) => {
                return (
                  <>
                    <Grid
                      container
                      sx={{
                        // display: "flex",
                        // justifyContent: "right",
                        // fontWeight: "bold",
                        margin: 0.8,
                        padding: theme.spacing(0.5),
                      }}
                    >
                      <Grid xs={4}>{item?.passengerName}</Grid>
                      <Grid xs={6}>
                        <StyledTextField
                          value={vehicleTotal}
                          onChange={(e) => setVehicleTotal(e.target.value)}
                          sx={{ width: "30%" }}
                          variant="outlined"
                          inputProps={{
                            style: {
                              padding: 0,
                            },
                          }}
                        />
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      sx={{
                        display: "flex",
                        justifyContent: "right",
                        margin: 0.8,
                      }}
                    >
                      <Grid
                        xs={3}
                        sx={{
                          marginRight: 1,
                          textAlign: "right",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          gap: 1,
                        }}
                      >
                        <Typography sx={{ fontSize: 20, fontWeight: "bold" }}>
                          Total (in{" "}
                          {item?.estimatedTotalAmount?.substring(0, 3)})
                        </Typography>
                        <Typography sx={{ fontSize: 20, fontWeight: "bold" }}>
                          {vehicleTotal}
                        </Typography>
                        {/* <StyledTextField
                        value={hotelTotal}
                        onChange={(e) => setHotelTotal(e.target.value)}
                        sx={{ width: "7%" }}
                        variant="outlined"
                        inputProps={{
                          style: {
                            padding: 0,
                            fontSize: 20,
                            fontWeight: "bold",
                          },
                        }}
                      /> */}
                      </Grid>
                    </Grid>
                  </>
                );
              })}
            </>
          ) : null}
        </Grid>
        <Grid container>
          {(filteredFields?.includes("UR") ||
            filteredFields?.includes("di") ||
            filteredFields?.includes("pr")) &&
            (itinerary_data?.remarks?.length > 0 ||
              itinerary_data?.di_remarks?.length > 0 ||
              itinerary_data?.passive_remarks?.length > 0) && (
              <>
                <Grid container sx={{ marginTop: 2 }}>
                  <Grid
                    xs={12}
                    sx={{
                      backgroundColor: "#3e3b39",
                      color: "white",
                      height: "4vh",
                      padding: 1,
                      fontSize: 18,
                      textTransform: "uppercase",
                    }}
                  >
                    Remark Information
                  </Grid>
                </Grid>
                {filteredFields?.includes("UR") &&
                  itinerary_data?.remarks?.length > 0 ? (
                  <>
                    <Grid
                      container
                      sx={{
                        marginTop: 1,
                        backgroundColor: "#d8d9da",
                        height: "4vh",
                        padding: 1,
                        fontSize: 18,
                      }}
                    >
                      <Grid xs={12}>Unassociated Remarks</Grid>
                    </Grid>
                    {itinerary_data?.remarks?.map((item) => {
                      return (
                        <Grid
                          container
                          sx={{
                            // margin: 0.8,
                            padding: theme.spacing(0.5),
                            // marginTop: 1
                          }}
                        >
                          <Grid xs={0.5}>
                            <Checkbox
                              sx={{ marginTop: -1, marginLeft: 1 }}
                              value={item}
                              checked={remarkInfo?.includes(item)}
                              onChange={() => handleRemarkSelection(item)}
                            />
                          </Grid>
                          <Grid xs={11.5} sx={{ marginTop: 0.5 }}>
                            {item}
                          </Grid>
                        </Grid>
                      );
                    })}
                  </>
                ) : null}
                {/* {filteredFields?.includes("npft") &&
                itinerary_data?.npft_remarks?.length > 0 ? (
                  <>
                    <Grid
                      container
                      sx={{
                        marginTop: 1,
                        backgroundColor: "#d8d9da",
                        height: "4vh",
                        padding: 1,
                        fontSize: 18,
                      }}
                    >
                      <Grid xs={12}>Notepad Remarks (NP FT)</Grid>
                    </Grid>
                    {itinerary_data?.npft_remarks?.map((item) => {
                      return (
                        <Grid
                          container
                          sx={{
                            // margin: 0.8,
                            padding: theme.spacing(0.5),
                            // marginTop: 1
                          }}
                        >
                          <Grid xs={0.5}>
                            <Checkbox
                              sx={{ marginTop: -1, marginLeft: 1 }}
                              value={item}
                              checked={npftRemark?.includes(item)}
                              onChange={() => handleNPFTRemarkSelection(item)}
                            />
                          </Grid>
                          <Grid xs={11.5} sx={{ marginTop: 0.5 }}>
                            {item}
                          </Grid>
                        </Grid>
                      );
                    })}
                  </>
                ) : null} */}
                {filteredFields?.includes("di") &&
                  itinerary_data?.di_remarks?.length > 0 ? (
                  <>
                    <Grid
                      container
                      sx={{
                        marginTop: 1,
                        backgroundColor: "#d8d9da",
                        height: "4vh",
                        padding: 1,
                        fontSize: 18,
                      }}
                    >
                      <Grid xs={12}>Accounting Remarks (DI)</Grid>
                    </Grid>
                    {itinerary_data?.di_remarks?.map((item) => {
                      return (
                        <Grid
                          container
                          sx={{
                            // margin: 0.8,
                            padding: theme.spacing(0.5),
                            // marginTop: 1
                          }}
                        >
                          <Grid xs={0.5}>
                            <Checkbox
                              sx={{ marginTop: -1, marginLeft: 1 }}
                              value={item}
                              checked={diRemark?.includes(item)}
                              onChange={() => handleDIRemarkSelection(item)}
                            />
                          </Grid>
                          <Grid xs={11.5} sx={{ marginTop: 0.5 }}>
                            {item}
                          </Grid>
                        </Grid>
                      );
                    })}
                  </>
                ) : null}
                {filteredFields?.includes("pr") &&
                  itinerary_data?.passive_remarks?.length > 0 ? (
                  <>
                    <Grid
                      container
                      sx={{
                        marginTop: 1,
                        backgroundColor: "#d8d9da",
                        height: "4vh",
                        padding: 1,
                        fontSize: 18,
                      }}
                    >
                      <Grid xs={12}>Passive Remarks</Grid>
                    </Grid>
                    {itinerary_data?.passive_remarks?.map((item) => {
                      return (
                        <Grid
                          container
                          sx={{
                            // margin: 0.8,
                            padding: theme.spacing(0.5),
                            // marginTop: 1
                          }}
                        >
                          <Grid xs={0.5}>
                            <Checkbox
                              sx={{ marginTop: -1, marginLeft: 1 }}
                              value={item}
                              checked={passiveRemark?.includes(item)}
                              onChange={() =>
                                handlePassiveRemarksSelection(item)
                              }
                            />
                          </Grid>
                          <Grid xs={11.5} sx={{ marginTop: 0.5 }}>
                            {item}
                          </Grid>
                        </Grid>
                      );
                    })}
                  </>
                ) : null}
              </>
            )}
        </Grid>
      </Grid>
      <Modal open={openModal} onClose={handleCloseModal}>
        <Box sx={modalStyle}>
          <Grid container sx={{ fontSize: 18 }}>
            {/* <Grid
              xs={12}
              sx={{ textAlign: "center", marginBottom: 4, fontSize: 25 }}
            >
              EMAIL ITINERARY
            </Grid> */}
            <Grid item xs={12} sx={{ marginTop: 2 }}>
              <FormControl>
                <FormLabel
                  sx={{
                    color: "black !important",
                    fontSize: 20,
                    fontWeight: "bold",
                    marginBottom: 1,
                  }}
                >
                  Please select your preferred PDF itinerary from the options
                  below.
                </FormLabel>
                <RadioGroup
                  // defaultValue={pdfChoice}
                  value={pdfChoice}
                  onChange={(e) => setpdfChoice(e.target.value)}
                >
                  {selectAllPassenger && (
                    <FormControlLabel
                      value="PDFA"
                      control={<Radio />}
                      label="PDF for all Pax"
                    />
                  )}
                  {selectAllPassenger && (
                    <FormControlLabel
                      value="PDFI"
                      control={<Radio />}
                      label="PDF for all individual Pax"
                    />
                  )}

                  {!selectAllPassenger && (
                    <FormControlLabel
                      value="PDFS"
                      control={<Radio />}
                      label="PDF for selected Pax"
                    />
                  )}
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid xs={12} sx={{ marginBottom: 1, marginTop: 2 }}>
              TO
            </Grid>
            <Grid xs={12}>
              <TextField
                fullWidth
                placeholder="Enter TO email"
                value={customerEmail}
                onChange={(e) => setCustomerEmail(e.target.value)}
              />
            </Grid>
            <Grid xs={12} sx={{ marginBottom: 1, marginTop: 2 }}>
              CC
            </Grid>
            <Grid xs={12}>
              <TextField
                fullWidth
                placeholder="Enter CC email"
                value={customerCC}
                onChange={(e) => setCustomerCC(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sx={{ marginTop: 2 }}>
              <FormControl>
                <FormLabel
                  sx={{
                    color: "black !important",
                    // fontSize: 20,
                    // fontWeight: "bold",
                    marginBottom: 1,
                  }}
                >
                  Select language
                </FormLabel>
                <RadioGroup
                  row
                  defaultValue={language}
                  value={language}
                  onChange={(e) => setLanguage(e.target.value)}
                >
                  <FormControlLabel
                    value="en"
                    control={<Radio />}
                    label="English"
                  />
                  <FormControlLabel
                    value="fr"
                    control={<Radio />}
                    label="French"
                  />
                  <FormControlLabel
                    value="tr"
                    control={<Radio />}
                    label="Turkish"
                  />
                  <FormControlLabel
                    value="zh"
                    control={<Radio />}
                    label="Chinese"
                  />
                  <FormControlLabel
                    value="ar"
                    control={<Radio />}
                    label="Arabic"
                  />
                  <FormControlLabel
                    value="es"
                    control={<Radio />}
                    label="Spanish"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid
              xs={12}
              sx={{
                display: "flex",
                justifyContent: "center",
                marginTop: 4,
              }}
            >
              <LoadingButton
                loading={emailItineraryLoading}
                type="submit"
                variant="contained"
                size="small"
                loadingPosition="start"
                sx={{
                  backgroundColor: "#282828",
                  width: "15%",
                  color: "#ffffff",
                  width: "20vh",
                  height: "4vh",
                  fontWeight: "bold",
                  fontSize: 14,
                  "&:hover": {
                    backgroundColor: "#282828",
                    color: "#ffffff",
                  },
                }}
                onClick={handleSendEmail}
              >
                Send
              </LoadingButton>
            </Grid>
            {errorAlert && (
              <Grid
                xs={12}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: 4,
                  color: "red",
                }}
              >
                {errorAlertMessage}
              </Grid>
            )}
          </Grid>
        </Box>
      </Modal>
      <Modal open={openPDFModal} onClose={handleClosePDFModal}>
        <Box sx={modalStyle}>
          <Grid container sx={{ fontSize: 18 }}>
            <Grid item xs={12} sx={{ marginTop: 2 }}>
              <FormControl>
                <FormLabel
                  sx={{
                    color: "black !important",
                    // fontSize: 20,
                    // fontWeight: "bold",
                    marginBottom: 1,
                  }}
                >
                  Select language
                </FormLabel>
                <RadioGroup
                  row
                  defaultValue={language}
                  value={language}
                  onChange={(e) => setLanguage(e.target.value)}
                >
                  <FormControlLabel
                    value="en"
                    control={<Radio />}
                    label="English"
                  />
                  <FormControlLabel
                    value="fr"
                    control={<Radio />}
                    label="French"
                  />
                  <FormControlLabel
                    value="tr"
                    control={<Radio />}
                    label="Turkish"
                  />
                  <FormControlLabel
                    value="zh"
                    control={<Radio />}
                    label="Chinese"
                  />
                  <FormControlLabel
                    value="ar"
                    control={<Radio />}
                    label="Arabic"
                  />
                  <FormControlLabel
                    value="es"
                    control={<Radio />}
                    label="Spanish"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid
              xs={12}
              sx={{
                display: "flex",
                justifyContent: "center",
                marginTop: 4,
              }}
            >
              <LoadingButton
                loading={printItineraryLoading}
                type="submit"
                variant="contained"
                size="small"
                loadingPosition="start"
                sx={{
                  backgroundColor: "#282828",
                  width: "15%",
                  color: "#ffffff",
                  width: "20vh",
                  height: "4vh",
                  fontWeight: "bold",
                  fontSize: 14,
                  "&:hover": {
                    backgroundColor: "#282828",
                    color: "#ffffff",
                  },
                }}
                onClick={handlePrintToPDF}
              >
                Print
              </LoadingButton>
            </Grid>
          </Grid>
        </Box>
      </Modal>
      {emailItineraryInfo && (
        <Snackbar
          open={snackOpen}
          autoHideDuration={5000}
          onClose={handleSnackClose}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          sx={{ width: "20%" }}
        >
          <Alert
            onClose={handleSnackClose}
            severity="success"
            sx={{ width: "100%" }}
          >
            <AlertTitle>Success</AlertTitle>
            {emailItineraryInfo}
          </Alert>
        </Snackbar>
      )}
      {emailItineraryError && (
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          open={snackOpen}
          autoHideDuration={3000}
          onClose={handleSnackClose}
          sx={{ width: "20%" }}
        >
          <Alert
            onClose={handleSnackClose}
            severity="error"
            sx={{ width: "100%" }}
          >
            <AlertTitle>Error</AlertTitle>
            {emailItineraryError}
          </Alert>
        </Snackbar>
      )}
    </Grid>
  ) : null;
}
